import { Component, ViewChild, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormArray,
} from '@angular/forms';
import * as L from 'leaflet';

declare var Cesium: any;
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  Subscription,
  timer,
} from 'rxjs';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { DtnService } from 'src/app/shared/service/dtn-service/dtn.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { VoyageRequestsService } from 'src/app/shared/service/voyage-requests/voyage-requests.service';
import { RoutingService } from '../../../../services/routing.service';
import { Port, AdvancedRouteGate, GeoJsonFeatureCollection } from '../../../../models/routing.models';
import { MatTabChangeEvent } from '@angular/material/tabs';


@Component({
  selector: 'app-initial-route-report',
  templateUrl: './initial-route-report.component.html',
  styleUrls: ['./initial-route-report.component.scss'],
})
export class InitialRouteReportComponent {
  requestForm!: FormGroup;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('route1Input', { static: false }) route1Input!: ElementRef;
  @ViewChild('route2Input', { static: false }) route2Input!: ElementRef;
  formSubmitted = false;
  isSubmitting = false;
  selectedType: string = 'jupiter Route';
  isLoadConditionRequired = false;
  isLoadStateRequired = false;
  isLoadStateDisabled = false;
  isYearToDateRequired = false;
  isWeatherLimitsNameSelected = false;
  locationSelectionEnabled = false;
  marker?: L.Marker;
  uploadedRoutePoints: any[] = [];
  uploadedRouteMarkers: any[] = [];
  routeLayer: any;
  selectedWaypointPoint: any = null;
  mapClickListener: any;
  mapHoverTooltip: any;
  mapMouseMoveListener: any;
  viaPoints: { lat: string; lon: string }[] = [];
  ports: any;
  private refreshSub!: Subscription;
  private dtnLayers: any = {};
  private token: string | null = null;
  private baseLayer!: L.TileLayer;

  // 3D Globe properties
  isGlobeMode = false;
  globeWeatherVisible = false;
  private cesiumLoaded = false;
  private globeViewer: any = null;
  private currentRouteCoords: [number, number][] = [];
  private currentTileSetId: string | null = null;
  private globeDtnImageryLayer: any = null;

  // Port & waypoint markers on 2D map
  private startPortMarker?: L.CircleMarker;
  private endPortMarker?: L.CircleMarker;
  private viaPointMarkers: L.CircleMarker[] = [];

  filteredPorts: any[] = [];

allReportTypes = {
  abb: [
    'Shortest path',
    'Instructed set speed',
    'Recommended set speed',
    'Fixed ETA',
    'Optimal set speed'
  ],
  meraki: [
    'Fixed ETA',
    'Optimal set speed',
    'jupiter Route',
    'Upload Route'
    
  ]
};
  private map!: L.Map;
  private layersControl!: L.Control.Layers;
  private shipMarker?: L.Marker;
  private routeLine?: L.Polyline;

  // Usage:
  private vessels: any[] = [];

  shipNameSuggestions: any[] = [];
  // Suggestions for <mat-autocomplete>
  simulationError: string | null = null;
  portNameSuggestions: any[] = [];
  filteredVessels: string[] = [];
  optimizationOptions = ['Fuel', 'Cost', 'Fuel Cost', 'Time'];
  dangerousCargoOptions = [
    'Dangerous Goods',
    'Radioactive Material',
    'Marpol Annex II Category X',
    'Marpol Annex II Category Y',
    'Marpol Annex II Category Z',
    'Marpol Annex II Others',
    'Marpol Annex I',
  ];
  loadConditionOptions = ['Loaded', 'PartiallyLoaded', 'Ballast'];
  loadStateOptions = ['Packaged', 'SolidBulk', 'LiquidBulk', 'OtherCargo'];
  vesselTypeOptions = [
    { label: 'Dry Bulk Carrier', value: 'DryBulkCarrier' },
    { label: 'Combination Carrier', value: 'CombinationCarrier' },
    { label: 'RoRo Vehicles Carrier', value: 'RoRoVehiclesCarrier' },
    { label: 'Chemical Tanker', value: 'ChemicalTanker' },
    { label: 'Container Vessel', value: 'ContainerVessel' },
    { label: 'Cruise Vessel', value: 'CruiseVessel' },
    { label: 'RoRo Cargo Ship', value: 'RoRoCargoShip' },
    { label: 'RoRo Passenger Ship', value: 'RoRoPassengerShip' },
    { label: 'Reefer Ship', value: 'ReeferShip' },
    { label: 'General Cargo Ship', value: 'GeneralCargoShip' },
    { label: 'Dredging Vessel', value: 'DredgingVessel' },
    { label: 'LNG Tanker', value: 'LNGTanker' },
    { label: 'LPG Tanker', value: 'LPGTanker' },
    { label: 'Oil Products Tanker', value: 'OilProductsTanker' },
    { label: 'Crude Oil Tanker', value: 'CrudeOilTanker' },
    { label: 'Other Tanker', value: 'OtherTanker' },
    { label: 'Tug', value: 'Tug' },
    { label: 'Yacht', value: 'Yacht' },
  ];
  filteredOptions = [
    { label: 'Dry Bulk Carrier', value: 'DryBulkCarrier' },
    { label: 'Combination Carrier', value: 'CombinationCarrier' },
    { label: 'RoRo Vehicles Carrier', value: 'RoRoVehiclesCarrier' },
    { label: 'Chemical Tanker', value: 'ChemicalTanker' },
    { label: 'Container Vessel', value: 'ContainerVessel' },
    { label: 'Cruise Vessel', value: 'CruiseVessel' },
    { label: 'RoRo Cargo Ship', value: 'RoRoCargoShip' },
    { label: 'RoRo Passenger Ship', value: 'RoRoPassengerShip' },
    { label: 'Reefer Ship', value: 'ReeferShip' },
    { label: 'General Cargo Ship', value: 'GeneralCargoShip' },
    { label: 'Dredging Vessel', value: 'DredgingVessel' },
    { label: 'LNG Tanker', value: 'LNGTanker' },
    { label: 'LPG Tanker', value: 'LPGTanker' },
    { label: 'Oil Products Tanker', value: 'OilProductsTanker' },
    { label: 'Crude Oil Tanker', value: 'CrudeOilTanker' },
    { label: 'Other Tanker', value: 'OtherTanker' },
    { label: 'Tug', value: 'Tug' },
    { label: 'Yacht', value: 'Yacht' },
  ];

  customAreasTypeOptions = ['No Go', 'Speed Limit', 'Emission Control'];
  emissionControlOptions = ['Maximum emission allowed', 'Emission Type'];
  emissionTypeOptions = ['Sulfur', 'Nitrogen'];
  warningSeverityOptions = ['Low', 'Moderate', 'Major', 'Critical'];
  icingRiskMaxOptions = ['Light', 'Moderate', 'Severe', 'Very Severe'];
  visibilityMinOptions = [
    'Poor',
    'Poor/Moderate',
    'Moderate',
    'Moderate/Good ',
  ];
  weatherLimitsNameTwoOptions: any;
  weatherLimitsNameOptions = [
    'Icing Risk',
    'Visibility',
    'Total Wave Height',
    'Beam Waves Height',
    'Following Waves Height',
    'Head Waves Height',
    'Risk Wave Height',
    'Wind Speed 10m',
    'Wind Speed 50m',
    'Wind Gusts 10m',
    'Wind Gusts 50m',
    'Head Wind Speed',
    'Beam Wind Speed',
    'Following Wind Speed',
    'Risk Wind Speed',
    'Ice Concentration',
    'Hurricane Distance',
    'Tropical Storm Distance',
    'Tropical Depression Distance',
    'Beam Waves Period',
    'Following Waves Period',
    'Head Waves Period',
  ];
  weatherLimitsActionTypeOptions = ['Avoid', 'Warn'];
  weatherSourceOptions = ['Climate', 'Forecast', 'Analysis'];
  filteredEndPorts: any[] = [];
  username: any;
  routeMarkersLayer: any;

  routingSpeed: number = 14;
  routingVesselType: string = 'handymax';
  avoidHra: boolean = false;
  avoidSuez: boolean = false;
  avoidPanama: boolean = false;
  isRoutingLoading: boolean = false;
  routingResults: any = null;
  layerState: any = {
    eca: false,
    hra: false,
    marpol: false,
    tss: false,
    piracy: false,
    inl: false,
    ports: false,
    gates: false,
  };
  isNearestLandMode: boolean = false;
  isDrawingMode: boolean = false;
  drawingMarkers: L.Marker[] = [];
  drawingPolyline?: L.Polyline;
  pickingTarget: number | 'origin' | 'dest' | null = null;
  isPickingMap: boolean = false;
  mouseLat: number = 0;
  mouseLng: number = 0;
  isSidebarCollapsed: boolean = true;
  conditionOptions: any = ["Laden", "Ballast"];
  // Where the plan's consumption comes from. The backend reads `fuelSource`
  // ("auto" = the vessel's fuel model when she has one, else the FC pairs;
  // "form" = always the FC pairs) and `calmWaterMethod`.
  fuelSourceOptions: any = ["Vessel fuel model", "FC speed/consumption pairs"];
  fuelSourceValues: any = { "Vessel fuel model": "auto", "FC speed/consumption pairs": "form" };
  fuelMethodOptions: any = ["Performance screen (3M calibrated)", "Holtrop 1984", "Sea trial (ISO 15016)"];
  fuelMethodValues: any = {
    "Performance screen (3M calibrated)": "screen_3m",
    "Holtrop 1984": "holtrop84",
    "Sea trial (ISO 15016)": "sea_trial",
  };

  isPrefillLoading: boolean = false;
  prefillLoadingTitle: string = 'Auto-populating Initial Route Form...';
  prefillLoadingSub: string = 'Loading vessel specifications, speed profiles, and port coordinates';

  private routingOverlayGroups: Record<string, L.LayerGroup> = {};
  private routingRouteLayer?: L.GeoJSON;
  private routingRouteMarkers: L.Layer[] = [];
  public activeGates: Set<string> = new Set();
  private loadedRoutingLayers: Set<string> = new Set();
  public gatesData: AdvancedRouteGate[] = [];
  private globeDataSources: Record<string, any> = {};
  private globeRouteDataSource: any = null;
  private zoneDataCache: Record<string, any> = {};
 selectedTab: boolean = true;
  constructor(
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private overlayService: OverlapService,
    private toastr: ToastrService,
    private dtnService: DtnService,
    private sharedDataService: DashboardService,
    private pcservice: PortRequestFormServiceService,
    private routingService: RoutingService,
    private voyageRequestsService: VoyageRequestsService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) { }

  ngOnInit() {
    this.selectedTab = true;
    this.username = localStorage.getItem('username');
    this.requestForm = this.fb.group(
      {
        reportType: [''],
        startLat: ['', Validators.required],
        startLon: ['', Validators.required],
        endLat: ['', Validators.required],
        endLon: ['', Validators.required],
        endPortName: ['', Validators.required],
        endPortId: [''],
        vesselName: ['', Validators.required],
        vesselType: ['', Validators.required],
        startPortName: ['', Validators.required],
        startPortId: [''],
        yearBuilt: [''],
        waypoint_comment: [''],
        weather_comment: [''],
        timeBetwPoints: [''],
        weatherForcRange: [''],
        timeBckInHours: [''],
        routeSummaryComment: [''],
        etdDate: [''],
        etdHours: [''],
        etdMinutes: [''],
        etaDate: [''],
        etahours: [''],
        etaMinutes: [''],
        etd: [''],
        eta: [''],
        imo: [''],
        optimizationType: [''],
        speed: [''],
        consumption: [''],
        fuel_cost_per_mt: [''],
        vessel_cost_per_day: [''],
        hire_cost_per_day:[''],
        maxSpeed: [''],
        minSpeed: [''],
        beam: [''],
        lengOfVessel: [''],
        airDraft: [''],
        deadWeight: [''],
        aftDraft: [''],
        foreDraft: [''],
        grossTonnage: [''],
        dangerousCargo: [''],
        loadCondition: [''],
        loadState: [''],
        yearToDateCo2Emissions: [''],
        yearToDateDistance: [''],
        hoursBetweenRouteWaypoints: [6],
        minimumHoursBetweenSpeedChanges: [''],
        issueTimeOfForecast: [''],
        otherFuelConsumption: [0],
        fuelCurveFuelUsageOne: [''],
        fuelCurveSpeedOne: [''],
        fuelCurveFuelUsageTwo: [''],
        fuelCurveSpeedTwo: [''],
        powerCurveSpeedOne: [''],
        powerCurveMaxContinuousRatingOne: [''],
        powerCurveSpeedTwo: [''],
        powerCurveMaxContinuousRatingTwo: [''],
        rpmSpeedOne: [''],
        rpmOne: [''],
        rpmSpeedTwo: [''],
        rpmTwo: [''],
        safetyMarginsPort: [0],
        safetyMarginsStarboard: [0],
        underKeel: [0],
        air: [0],
        aft: [0],
        forward: [0],
        vesselCost: [''],
        fuelCost: [''],
        ecaFuelCost: [''],
        otherFuelCost: [''],
        northVertex: [80],
        southVertex: [80],
        areaId: [''],
        enabled: [''],
        custAreasLatOne: [''],
        custAreasLonOne: [''],
        custAreasLatTwo: [''],
        custAreasLonTwo: [''],
        custAreasLatThree: [''],
        custAreasLonThree: [''],
        custAreasLatFour: [''],
        custAreasLonFour: [''],
        custAreasName: [''],
        custAreasType: [''],
        speedLimit: [''],
        maxEmissionAllowed: [''],
        emissionType: [''],
        weatherLimitsNameOne: ['Icing Risk'],
        weatherLimitsNameTwo: [''],
        icingRiskMax: [''],
        visibilityMin: [''],
        weatherLimitsActionType: [''],
        warningSeverity: [''],
        portsLat: [''],
        portsLon: [''],
        weatherSource: [''],

        totalWaveHeightMax: [''],
        beamWaveHeightMax: [''],
        followingWaveHeightMax: [''],
        headWaveHeightMax: [''],
        riskWaveHeightMax: [''],
        windSpeedTenMax: [''],
        windSpeedFiftyMax: [''],
        windGustsTenMax: [''],
        windGustsFiftyMax: [''],
        headWindSpeedMax: [''],
        beamWindSpeedMax: [''],
        followingWindSpeedMax: [''],
        riskWindSpeedMax: [''],
        iceConcentrationMax: [''],
        hurricaneDistanceMin: [''],
        tropicalStormDistanceMin: [''],
        tropicalDepressionDistanceMin: [''],
        beamWavePeriodMax: [''],
        beamWavePeriodMin: [''],
        followingWavePeriodMax: [''],
        followingWavePeriodMin: [''],
        headWavePeriodMax: [''],
        headWavePeriodMin: [''],
        ship_length: [''],
        ship_breadth: [''],
        wind_drag_coefficient: [''],
        air_density: [''],
        empirical_constant: ['0.01'],
        power_inp: [''],
        windage_area: [''],
        condition: [''],
        speed_min: [''],
        speed_max: [''],
        rough_wave_h: ['4.0'],
        rough_wind_spd: ['28.0'],
        moderate_wave_h: ['2.0'],
        moderate_wind: ['14.0'],
        strom_BF:[''],
         wait_hours:[''],
          speed_margin:[''],
          fc_speed1:[''],
          fc_consumption1:[''],
          fc_speed2:[''],
          fc_consumption2:[''],
            stop_wind_kn:[''],
          stop_fuel_rate:[''],
          // Fuel model. Draft in metres; blank = her draft for the
          // Condition chosen above.
          draft: [''],
          fuelSource: ['Vessel fuel model'],
          calmWaterMethod: ['Performance screen (3M calibrated)'],
          // Where she is when the plan starts. The engine cannot infer this,
          // and getting it wrong is expensive both ways: alongside, a hold at
          // the first waypoint is free, uncapped and never checked for
          // weather; at sea the same hold burns stop-fuel, is capped at 24 h,
          // is checked, and she drifts with the current while she lies there.
          vesselAtSea: [false],
          // How far she may drift on a hold before starting up and regaining
          // position. 30-35 nm in open water; cut to about 10 near land or a
          // national boundary. Only means anything at sea.
          driftRadiusNm: ['32'],
      },
      { validators: [this.yearToDateValidator()] },
    );
    this.addViaPoint();
    this.setupFormLogic();
    this.setupYearToDateLiveValidation();
    this.fetchAllVessels();

    // Listen for vessel name changes
    this.requestForm.get('vesselName')?.valueChanges.subscribe((name) => {
      if (this.vessels && this.vessels.length) {
        const v = this.vessels.find((v: any) => v.vessel_name === name);
        if (v) {
          this.requestForm.patchValue({ imo: v.imo });
        }
      }
    });

    // Listen for speed/condition changes to auto-fill consumption
    this.requestForm.get('speed')?.valueChanges.subscribe(() => {
      this.autoFillConsumption();
    });
    this.requestForm.get('condition')?.valueChanges.subscribe((cond) => {
      this.autoFillConsumption();
      if (this.routeComparisons && this.routeComparisons.controls) {
        this.routeComparisons.controls.forEach((ctrl) => {
          if (ctrl instanceof FormGroup) {
            this.autoFillOptionConsumption(ctrl);
          }
        });
      }
    });
    this.requestForm
      .get('imo')
      ?.valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        filter((imo) => !!imo),
      )
      .subscribe((imo) => {
        if (this.vessels && this.vessels.length) {
          const v = this.vessels.find((v: any) => v.imo === imo);
          if (v) {
            this.requestForm.patchValue(
              { vesselName: v.vessel_name },
              { emitEvent: false },
            );
          }
        }

        this.getFormDetails(imo);
        this.getAisPosition(imo);
        this.fetchTcpSpeedConsumption(imo);
      });

    this.requestForm
      .get('weatherLimitsNameOne')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Beam Waves Height') {
          this.requestForm
            .get('weatherLimitsNameTwo')
            ?.setValue('Beam Waves Period');
          this.isWeatherLimitsNameSelected = true;
        } else if (value === 'Following Waves Height') {
          this.isWeatherLimitsNameSelected = true;
          this.requestForm
            .get('weatherLimitsNameTwo')
            ?.setValue('Following Waves Period');
        } else if (value === 'Head Waves Height') {
          this.isWeatherLimitsNameSelected = true;
          this.requestForm
            .get('weatherLimitsNameTwo')
            ?.setValue('Head Waves Period');
        } else if (value === 'Beam Waves Period') {
          this.isWeatherLimitsNameSelected = true;
          this.requestForm
            .get('weatherLimitsNameTwo')
            ?.setValue('Beam Waves Height');
        } else if (value === 'Following Waves Period') {
          this.isWeatherLimitsNameSelected = true;
          this.requestForm
            .get('weatherLimitsNameTwo')
            ?.setValue('Following Waves Height');
        } else if (value === 'Head Waves Period') {
          this.isWeatherLimitsNameSelected = true;
          this.requestForm
            .get('weatherLimitsNameTwo')
            ?.setValue('Head Waves Height');
        } else {
          this.isWeatherLimitsNameSelected = false;
        }
      });

    this.requestFormService.getPortDetailsDtn().subscribe((data) => {
      this.ports = data;
    });

    // Watch coordinate fields for manual typing → update markers
    ['startLat', 'startLon', 'endLat', 'endLon'].forEach((field) => {
      this.requestForm.get(field)?.valueChanges.subscribe(() => {
        this.updatePortMarkers();
      });
    });

    this.initializeMap();

    // Check for pre-fill from BehaviorSubject OR queryParams (on refresh)
    this.route.queryParams.subscribe((params: any) => {
      const fromRequestId = params?.fromRequestId;
      const currentPrefill = this.voyageRequestsService.getPrefillData();

      if (currentPrefill && (!fromRequestId || currentPrefill.id === fromRequestId)) {
        this.ngZone.run(() => {
          this.isPrefillLoading = true;
          this.prefillLoadingTitle = `Auto-populating Route Form from Request ${currentPrefill.id || ''}`;
          this.prefillLoadingSub = `Configuring ${currentPrefill.vesselName || 'Vessel'} (${currentPrefill.startPort || 'Origin'} ➔ ${currentPrefill.endPort || 'Destination'})...`;
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          this.applyVoyageRequestPrefill(currentPrefill);
        });
      } else if (fromRequestId) {
        // Page was reloaded directly via URL with ?fromRequestId=...
        this.isPrefillLoading = true;
        this.prefillLoadingTitle = `Fetching Voyage Request ${fromRequestId}...`;
        this.prefillLoadingSub = 'Loading saved voyage parameters...';
        this.cdr.markForCheck();
        this.cdr.detectChanges();

        this.voyageRequestsService.getRequestById(fromRequestId).subscribe({
          next: (res: any) => {
            const data = res?.data;
            if (data) {
              this.ngZone.run(() => {
                this.voyageRequestsService.setPrefillForInitialRoute(data);
                this.isPrefillLoading = true;
                this.prefillLoadingTitle = `Auto-populating Route Form from Request ${data.id || fromRequestId}`;
                this.prefillLoadingSub = `Configuring ${data.vesselName || 'Vessel'} (${data.startPort || 'Origin'} ➔ ${data.endPort || 'Destination'})...`;
                this.cdr.markForCheck();
                this.cdr.detectChanges();
                this.applyVoyageRequestPrefill(data);
              });
            } else {
              this.isPrefillLoading = false;
              this.cdr.markForCheck();
              this.cdr.detectChanges();
            }
          },
          error: (err) => {
            console.error('Failed to restore voyage request on refresh:', err);
            this.isPrefillLoading = false;
            this.cdr.markForCheck();
            this.cdr.detectChanges();
          }
        });
      }
    });

    this.voyageRequestsService.prefillData$.subscribe((prefill) => {
      if (prefill) {
        this.ngZone.run(() => {
          this.isPrefillLoading = true;
          this.prefillLoadingTitle = `Auto-populating Route Form from Request ${prefill.id || ''}`;
          this.prefillLoadingSub = `Configuring ${prefill.vesselName || 'Vessel'} (${prefill.startPort || 'Origin'} ➔ ${prefill.endPort || 'Destination'})...`;
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          this.applyVoyageRequestPrefill(prefill);
        });
      }
    });

    // TEMP: load demo route for testing — comment out later
    // this.loadDemoRoute();
  }

  private applyVoyageRequestPrefill(prefill: any): void {
    if (!prefill || !this.requestForm) {
      this.ngZone.run(() => {
        this.isPrefillLoading = false;
        this.cdr.detectChanges();
      });
      return;
    }

    const patch: any = {};
    if (prefill.vesselName) patch.vesselName = prefill.vesselName;
    if (prefill.imo) patch.imo = prefill.imo;
    if (prefill.vesselType) patch.vesselType = prefill.vesselType;
    if (prefill.yearBuilt) patch.yearBuilt = prefill.yearBuilt;

    const condition = prefill.condition || prefill.rawPayload?.condition || 'Laden';
    patch.condition = condition;

    if (prefill.startPort) patch.startPortName = prefill.startPort;
    if (prefill.startLat != null && prefill.startLat !== '') patch.startLat = prefill.startLat;
    if (prefill.startLon != null && prefill.startLon !== '') patch.startLon = prefill.startLon;
    if (prefill.startLong != null && prefill.startLong !== '') patch.startLon = prefill.startLong;
    if (prefill.startPortId || prefill.startUnlocode) patch.startPortId = prefill.startPortId || prefill.startUnlocode;

    if (prefill.endPort) patch.endPortName = prefill.endPort;
    if (prefill.endLat != null && prefill.endLat !== '') patch.endLat = prefill.endLat;
    if (prefill.endLon != null && prefill.endLon !== '') patch.endLon = prefill.endLon;
    if (prefill.endLong != null && prefill.endLong !== '') patch.endLon = prefill.endLong;
    if (prefill.endPortId || prefill.endUnlocode) patch.endPortId = prefill.endPortId || prefill.endUnlocode;

    if (prefill.departureDate) patch.etdDate = prefill.departureDate;
    if (prefill.departureTime) {
      const parts = String(prefill.departureTime).split(':');
      if (parts.length >= 2) {
        patch.etdHours = parseInt(parts[0], 10);
        patch.etdMinutes = parseInt(parts[1], 10);
      }
    }

    if (prefill.dailyRate) {
      patch.hire_cost_per_day = prefill.dailyRate;
      patch.vessel_cost_per_day = prefill.dailyRate;
    }
    if (prefill.vlsfoPrice || prefill.hsfoPrice) {
      patch.fuelCost = prefill.vlsfoPrice || prefill.hsfoPrice;
      patch.fuel_cost_per_mt = prefill.vlsfoPrice || prefill.hsfoPrice;
    }
    if (prefill.lsmgoPrice) patch.ecaFuelCost = prefill.lsmgoPrice;

    if (prefill.underKeel != null) patch.underKeel = prefill.underKeel;
    if (prefill.airDraft != null) patch.air = prefill.airDraft;
    if (prefill.aftDraft != null) patch.aft = prefill.aftDraft;
    if (prefill.forwardDraft != null) patch.forward = prefill.forwardDraft;

    if (prefill.maxWind != null) patch.windSpeedTenMax = prefill.maxWind;
    if (prefill.maxWave != null) patch.totalWaveHeightMax = prefill.maxWave;

    if (prefill.speed != null) patch.speed = prefill.speed;
    if (prefill.consumption != null) patch.consumption = prefill.consumption;
    if (prefill.speedSets && Array.isArray(prefill.speedSets) && prefill.speedSets.length > 0) {
      const firstSet = prefill.speedSets[0];
      if (firstSet.speed) patch.speed = firstSet.speed;
      if (firstSet.consumption) patch.consumption = firstSet.consumption;
      if (firstSet.condition) patch.condition = firstSet.condition;
    }

    if (prefill.optimizationType) {
      if (prefill.optimizationType === 'Optimized Speed') {
        patch.optimizationType = 'Optimal set speed';
      } else if (prefill.optimizationType === 'Fixed ETA') {
        patch.optimizationType = 'Fixed ETA';
      } else {
        patch.optimizationType = 'Instructed set speed';
      }
    }

    patch.empirical_constant = '0.01';
    this.requestForm.patchValue(patch);
    this.cdr.markForCheck();
    this.cdr.detectChanges();

    // Auto-resolve coordinates from DTN port database
    const applyCoordsFromPortList = (portList: any[]) => {
      if (!portList || !portList.length) return;

      const findPort = (portNameStr: string) => {
        if (!portNameStr) return null;
        const q = String(portNameStr).toLowerCase().replace(/[^a-z0-9]/g, '');
        return portList.find((p: any) => {
          const n1 = String(p?.properties?.name || p?.port_name || p?.port || p?.name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          const n2 = String(p?.properties?.unlocode || p?.port_code || p?.unlocode || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          return n1 === q || (q.length > 3 && (n1.startsWith(q) || q.startsWith(n1))) || (n2 && n2 === q);
        });
      };

      const startMatch = findPort(prefill.startPort || patch.startPortName);
      if (startMatch) {
        const sId = startMatch.properties?.id || startMatch.id || '';
        if (sId) {
          this.requestForm.patchValue({ startPortId: sId });
        }
      }

      const endMatch = findPort(prefill.endPort || patch.endPortName);
      if (endMatch) {
        let eLat: any = null;
        let eLon: any = null;
        const eId = endMatch.properties?.id || endMatch.id || '';
        if (endMatch.geometry?.coordinates && Array.isArray(endMatch.geometry.coordinates)) {
          eLon = Number(endMatch.geometry.coordinates[0]).toFixed(6);
          eLat = Number(endMatch.geometry.coordinates[1]).toFixed(6);
        } else {
          eLat = endMatch.latitude != null ? Number(endMatch.latitude).toFixed(6) : (endMatch.lat != null ? Number(endMatch.lat).toFixed(6) : null);
          eLon = endMatch.longitude != null ? Number(endMatch.longitude).toFixed(6) : (endMatch.lon != null ? Number(endMatch.lon).toFixed(6) : null);
        }
        if (eLat != null && eLon != null) {
          this.requestForm.patchValue({
            endPortId: eId,
            endLat: eLat,
            endLon: eLon
          });
        }
      }

      this.updatePortMarkers();
      this.cdr.detectChanges();
    };

    if (this.ports && this.ports.length) {
      applyCoordsFromPortList(this.ports);
    } else {
      this.requestFormService.getPortDetailsDtn().subscribe((data: any) => {
        this.ngZone.run(() => {
          this.ports = data;
          applyCoordsFromPortList(data);
        });
      });
    }

    // Fetch and auto-populate ship dimensions, windage areas, and coefficients
    if (prefill.imo) {
      this.getFormDetails(prefill.imo);
    }

    // If mid-port itinerary exists, add via points
    if (prefill.itinerary && Array.isArray(prefill.itinerary) && prefill.itinerary.length > 0) {
      prefill.itinerary.forEach((stop: any, idx: number) => {
        if (idx >= this.viaPoints.length) {
          this.addViaPoint();
        }
        const latKey = `viaLat_${idx + 1}`;
        const lonKey = `viaLon_${idx + 1}`;
        if (stop.lat != null && this.requestForm.contains(latKey)) {
          this.requestForm.get(latKey)?.setValue(stop.lat);
        }
        if (stop.long != null && this.requestForm.contains(lonKey)) {
          this.requestForm.get(lonKey)?.setValue(stop.long);
        }
      });
    }

    this.updatePortMarkers();

    // Dismiss loading overlay smoothly
    setTimeout(() => {
      this.ngZone.run(() => {
        this.isPrefillLoading = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      });
    }, 400);
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.off();
      this.map.remove();
    }
    const container = document.getElementById('map');
    if (container && (container as any)._leaflet_id) {
      (container as any)._leaflet_id = null;
    }
  }
  private lastQuickOnboardingImo?: string;
  private isFetchingQuickOnboarding = false;

  getFormDetails(imo: any) {
    const strImo = String(imo || '').trim();
    if (!strImo) return;
    if (this.lastQuickOnboardingImo === strImo && this.isFetchingQuickOnboarding) {
      return;
    }
    this.lastQuickOnboardingImo = strImo;
    this.isFetchingQuickOnboarding = true;

    this.pcservice.quickOnboarding(strImo).subscribe({
      next: (res: any) => {
        this.isFetchingQuickOnboarding = false;
        const data = res?.data;

        if (!data) return;

        this.ngZone.run(() => {
          const currentCond = this.requestForm.get('condition')?.value || 'Laden';
          const windage = String(currentCond).toLowerCase().includes('ballast')
            ? (data.weather_data?.windage_area_ballast || data.weather_data?.windage_area_laden)
            : (data.weather_data?.windage_area_laden || data.weather_data?.windage_area_ballast);

          this.requestForm.patchValue({
            vesselName: data.vessel_name,
            vesselType: data.type_of_vessel,
            yearBuilt: data.year_built,

            lengOfVessel: data.lengOfVessel,
            grossTonnage: data.grossTonnage,
            deadWeight: data.loadline_summer_deadweight_metric_tonnes,

            ship_length: data.lengOfVessel,
            beam: data.beam,
            ship_breadth: data.beam,

            air_density: data.weather_data?.air_density || 1.225,
            empirical_constant: data.weather_data?.empirical_constant || '0.01',
            power_inp: data.weather_data?.engine_power,
            wind_drag_coefficient: data.weather_data?.wind_track_coeff,
            windage_area: windage,
            windageAreaLaden: data.weather_data?.windage_area_laden,
            windageAreaBallast: data.weather_data?.windage_area_ballast,
          });

          this.cdr.markForCheck();
          this.cdr.detectChanges();
        });

        this.fetchTcpSpeedConsumption(strImo);
      },

      error: (err) => {
        this.isFetchingQuickOnboarding = false;
        console.error(err);
      },
    });
  }
  // TEMP: demo route — comment out later ─────────────────────────
  private loadDemoRoute(): void {
    const raw: { lat: number; lon: number }[] = [
      { lat: -38.3385, lon: 144.5842 },
      { lat: -38.3902, lon: 144.4433 },
      { lat: -38.5245, lon: 144.4477 },
      { lat: -38.9503, lon: 144.7402 },
      { lat: -39.272, lon: 146.212 },
      { lat: -39.2672, lon: 146.5603 },
      { lat: -39.1192, lon: 147.0208 },
      { lat: -39.6498, lon: 151.2642 },
      { lat: -40.0908, lon: 155.5693 },
      { lat: -40.3743, lon: 159.9047 },
      { lat: -40.4867, lon: 164.2698 },
      { lat: -40.4485, lon: 168.6125 },
      { lat: -40.217, lon: 173.0847 },
      { lat: -40.372, lon: 174.1367 },
      { lat: -40.8342, lon: 174.553 },
      { lat: -41.4232, lon: 174.4763 },
      { lat: -41.8515, lon: 174.9305 },
      { lat: -52.6103, lon: -74.8372 },
      { lat: -52.656, lon: -74.6183 },
      { lat: -52.8768, lon: -74.0313 },
      { lat: -53.0903, lon: -73.4642 },
      { lat: -53.2685, lon: -73.2233 },
      { lat: -53.505, lon: -72.6635 },
      { lat: -53.5523, lon: -72.563 },
      { lat: -53.5523, lon: -72.3858 },
      { lat: -53.5755, lon: -72.3293 },
      { lat: -53.6928, lon: -72.1252 },
      { lat: -53.7958, lon: -71.8853 },
      { lat: -53.9278, lon: -71.2712 },
      { lat: -53.8135, lon: -70.9088 },
      { lat: -53.1305, lon: -70.6532 },
      { lat: -52.9653, lon: -70.4913 },
      { lat: -52.7777, lon: -70.4807 },
      { lat: -52.7377, lon: -70.4352 },
      { lat: -52.7072, lon: -70.2112 },
      { lat: -52.5942, lon: -69.726 },
      { lat: -52.5332, lon: -69.6255 },
      { lat: -52.4742, lon: -69.545 },
      { lat: -52.4147, lon: -69.4237 },
      { lat: -52.3525, lon: -69.3137 },
      { lat: -52.353, lon: -69.1337 },
      { lat: -52.3697, lon: -69.0353 },
      { lat: -52.3793, lon: -68.9778 },
      { lat: -52.5107, lon: -68.5008 },
      { lat: -52.6448, lon: -68.2627 },
      { lat: -52.6462, lon: -67.8592 },
      { lat: -38.2797, lon: -52.6202 },
      { lat: -23.6835, lon: -41.205 },
      { lat: -21.2108, lon: -39.7432 },
    ];

    // Normalize antimeridian crossing
    const normalized = [raw[0]];
    for (let i = 1; i < raw.length; i++) {
      const prev = normalized[i - 1];
      const curr = { ...raw[i] };
      const diff = curr.lon - prev.lon;
      if (diff > 180) curr.lon -= 360;
      else if (diff < -180) curr.lon += 360;
      normalized.push(curr);
    }

    const coords: [number, number][] = normalized.map((p) => [p.lat, p.lon]);
    this.drawSeaRoute(coords);
    this.addWhiteCircles(coords);
  }
  // END TEMP ─────────────────────────────────────────────────────
  initializeMap() {
    if (this.map) {
      this.map.off();
      this.map.remove();
    }
    const container = document.getElementById('map');
    if (container && (container as any)._leaflet_id) {
      (container as any)._leaflet_id = null;
    }
    this.map = L.map('map', {
      center: [20, 80],
      zoom: 4,
      minZoom: 1, // user cannot zoom out below this level
      maxZoom: 19,
    });

    // --- Base Map ---
    this.baseLayer = L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    ).addTo(this.map);

    this.map.createPane('weatherPane');
    this.map.createPane('referencePane');
    this.map.getPane('weatherPane')!.style.zIndex = '350';
    this.map.getPane('referencePane')!.style.zIndex = '380';

    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
      {
        pane: 'referencePane',
      },
    ).addTo(this.map);

    // --- Layer Control ---
    this.layersControl = L.control
      .layers(
        { 'Base Map': this.baseLayer }, // base layers
        {}, // start with empty overlays
        { collapsed: false },
      )
      .addTo(this.map);

    // Create a placeholder layer for Wind Speed to trigger lazy loading
    const windPlaceholder = L.layerGroup();
    this.layersControl.addOverlay(windPlaceholder, 'Wind Speed');

    this.map.on('overlayadd', (e: L.LayersControlEvent) => {
      if (e.name === 'Wind Speed' && !this.dtnLayers['Wind Speed']) {
        if (!this.token || !this.currentTileSetId) {
          this.dtnService.getToken().subscribe({
            next: (res) => {
              this.token = res.data.access_token;
              const layerId = 'fcst-onefx-wind-speed-contours';
              this.dtnService
                .getLatestTileSetId(layerId, this.token!)
                .subscribe({
                  next: (tileSetId: string) => {
                    this.currentTileSetId = tileSetId;
                    this.updateDtnLayers(tileSetId);
                    // Replace placeholder with real layer
                    this.map.removeLayer(windPlaceholder);
                    const layer = this.dtnLayers['Wind Speed'];
                    if (layer) {
                      (layer as any).addTo(this.map);
                    }
                  },
                });
            },
          });
        } else {
          // Already have token/id, just add real layer
          this.updateDtnLayers(this.currentTileSetId);
          this.map.removeLayer(windPlaceholder);
          const layer = this.dtnLayers['Wind Speed'];
          if (layer) {
            (layer as any).addTo(this.map);
          }
        }
      }
    });
    const hoverTooltip = L.tooltip({
      permanent: false,
      direction: 'top',
      offset: [0, -10],
      opacity: 0.9,
    });

    this.map.on('mousemove', (e: any) => {
      const lat = Number(e.latlng.lat.toFixed(6));

      let lng = Number(e.latlng.lng.toFixed(6));

      // normalize longitude
      if (lng > 180) lng -= 360;
      if (lng < -180) lng += 360;

      hoverTooltip.setLatLng(e.latlng).setContent(`
    <div>
      <b>Lat:</b> ${lat}<br/>
      <b>Lng:</b> ${lng}
    </div>
  `);

      if (!this.map.hasLayer(hoverTooltip)) {
        hoverTooltip.addTo(this.map);
      }
    });

    this.map.on('mouseout', () => {
      if (this.map.hasLayer(hoverTooltip)) {
        this.map.removeLayer(hoverTooltip);
      }
    });
  }

  loadTokenAndAddLayers(forceReload = false) {
    if (this.token && !forceReload) {
      this.loadTileSetIdAndAddLayers();
      return;
    }

    this.dtnService.getToken().subscribe({
      next: (res) => {
        this.token = res.data.access_token;
        this.loadTileSetIdAndAddLayers();
      },
      error: (err) => console.error('DTN token fetch failed:', err),
    });
  }

  getAisPosition(imo: any) {
    if (!imo) return;
    this.requestFormService.getkplerList([imo]).subscribe({
      next: (data) => {
        const ais = data?.data?.[0]?.AIS;
        const lat = ais?.LATITUDE;
        const lon = ais?.LONGITUDE;
        if (lat != null && lon != null) {
          this.ngZone.run(() => {
            this.requestForm.patchValue({
              startLat: String(Number(lat).toFixed(6)),
              startLon: String(Number(lon).toFixed(6)),
            });
            this.flyToPoint(Number(lat), Number(lon));
            this.updatePortMarkers();
            this.cdr.markForCheck();
            this.cdr.detectChanges();
          });
        }
      },
      error: () => {}
    });
  }

  loadTileSetIdAndAddLayers() {
    if (!this.token) return;

    const layerId = 'fcst-onefx-wind-speed-contours';

    this.dtnService.getLatestTileSetId(layerId, this.token).subscribe({
      next: (tileSetId: any) => {
        this.currentTileSetId = tileSetId;
        this.updateDtnLayers(tileSetId);
      },
      error: (err: any) => console.error('Failed to load tileSetId:', err),
    });
  }

  updateDtnLayers(tileSetId: string) {
    if (!this.token) return;

    const token = this.token;

    const layerDefs: Record<string, string> = {
      'Wind Speed': `https://map.api.dtn.com/v2/tiles/fcst-onefx-wind-speed-contours/${tileSetId}/{z}/{x}/{y}?unit=metric&token=${token}`,
    };

    // remove old layers from map if any
    Object.values(this.dtnLayers).forEach((layer) => {
      if (this.map.hasLayer(layer as any)) {
        this.map.removeLayer(layer as any);
      }
    });
    this.dtnLayers = {};

    // create DTN layers and add to control
    Object.entries(layerDefs).forEach(([name, url]) => {
      const layer = L.tileLayer(url, {
        opacity: 0.65,
        pane: 'weatherPane',
        crossOrigin: true,
        noWrap: false,
      });
      this.dtnLayers[name] = layer;
      this.layersControl.addOverlay(layer, name);
    });
  }

  yearToDateValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const co2 = group.get('yearToDateCo2Emissions')?.value?.trim();
      const distance = group.get('yearToDateDistance')?.value?.trim();

      if ((co2 && !distance) || (!co2 && distance)) {
        return { yearToDateMismatch: true };
      }
      return null;
    };
  }

  // 🔹 Track live changes to set required flag dynamically
  setupYearToDateLiveValidation(): void {
    this.requestForm
      .get('yearToDateCo2Emissions')
      ?.valueChanges.subscribe(() => {
        this.isYearToDateRequired = !!(
          this.requestForm.get('yearToDateCo2Emissions')?.value ||
          this.requestForm.get('yearToDateDistance')?.value
        );
      });

    this.requestForm.get('yearToDateDistance')?.valueChanges.subscribe(() => {
      this.isYearToDateRequired = !!(
        this.requestForm.get('yearToDateCo2Emissions')?.value ||
        this.requestForm.get('yearToDateDistance')?.value
      );
    });
  }

  setupFormLogic(): void {
    const dangerousCargoControl = this.requestForm.get('dangerousCargo');
    const loadConditionControl = this.requestForm.get('loadCondition');
    const loadStateControl = this.requestForm.get('loadState');

    // 🔹 Rule 1: DangerousCargo not empty → LoadCondition & LoadState required
    dangerousCargoControl?.valueChanges.subscribe((cargo) => {
      const hasCargo = cargo && cargo.trim() !== '';
      this.isLoadConditionRequired = hasCargo;
      this.isLoadStateRequired = hasCargo;

      // Update form control validators to match UI
      if (hasCargo) {
        loadConditionControl?.setValidators([Validators.required]);
        loadStateControl?.setValidators([Validators.required]);
      } else {
        loadConditionControl?.clearValidators();
        loadStateControl?.clearValidators();
      }

      loadConditionControl?.updateValueAndValidity();
      loadStateControl?.updateValueAndValidity();
    });

    // 🔹 Rule 2: LoadCondition = Ballast → clear & disable LoadState
    loadConditionControl?.valueChanges.subscribe((condition) => {
      if (condition === 'Ballast') {
        loadStateControl?.reset();
        loadStateControl?.disable();
        this.isLoadStateDisabled = true;
        this.isLoadStateRequired = false;
      } else {
        loadStateControl?.enable();
        this.isLoadStateDisabled = false;

        // Reapply DangerousCargo rule
        if (this.requestForm.get('dangerousCargo')?.value) {
          this.isLoadStateRequired = true;
        }
      }
    });
  }

  fuelCurveOpen: boolean = false;

  toggleFuelCurve() {
    this.fuelCurveOpen = !this.fuelCurveOpen;
  }

  powerCurveOpen: boolean = false;

  togglePowerCurve() {
    this.powerCurveOpen = !this.powerCurveOpen;
  }

  rmpCurveOpen: boolean = false;

  toggleRmpCurve() {
    this.rmpCurveOpen = !this.rmpCurveOpen;
  }
  saftyMarginOpen: boolean = false;

  toggleSaftyMargin() {
    this.saftyMarginOpen = !this.saftyMarginOpen;
  }
  costOpen: boolean = false;

  toggleCost() {
    this.costOpen = !this.costOpen;
  }

  restrictionsOpen: boolean = false;

  toggleRestrictions() {
    this.restrictionsOpen = !this.restrictionsOpen;
  }
  voyageOpen: boolean = false;

  toggleVoyage() {
    this.voyageOpen = !this.voyageOpen;
  }

  private updateShipMarker(coords: [number, number]) {
    if (this.shipMarker) {
      this.shipMarker.setLatLng(coords);
    } else {
      this.shipMarker = L.marker(coords)
        .addTo(this.map)
        .bindPopup('Ship Position');
    }
    this.map.setView(coords, 5);
  }

  private drawRoute(start: [number, number], end: [number, number]) {
    if (this.routeLine) {
      this.routeLine.remove();
    }
    this.routeLine = L.polyline([start, end], { color: 'blue' }).addTo(
      this.map,
    );
    this.map.fitBounds([start, end]);
  }

  createShipIcon(shipName: string): L.DivIcon {
    return L.divIcon({
      className: 'custom-ship-icon',
      html: `
      <div style="text-align:center;">
        <i class="fa-sharp fa-solid fa-ship" style="color:#0e0ded;font-size:15px;"></i>
        <div style="font-size:12px;white-space:nowrap;">${shipName}</div>
      </div>
    `,
      iconSize: [28, 28],
      iconAnchor: [14, 28], // Center bottom anchor
      popupAnchor: [0, -28],
    });
  }

  selectReportType(type: string) {
    this.selectedType = type;
    const cleanValue = type.replace(/\s+/g, '');
    this.requestForm.patchValue({ reportType: cleanValue });
  }

  getIcon(type: string) {
    switch (type) {
      case 'Instructed set speed':
        return 'fa-ship';
      case 'Recommended set speed':
        return 'fa-anchor';
      case 'Fixed ETA':
        return 'fa-clock';
      case 'jupiter Route':
        return 'fa-route';
      case 'Upload Route':
        return 'fa-upload';
      default:
        return 'fa-compass';
    }
  }

  filterShipNames(event: any) {
    const value = event?.target?.value?.trim().toLowerCase();
    if (value && Array.isArray(this.vessels)) {
      this.shipNameSuggestions = this.vessels.filter((v: any) =>
        v?.vessel_name?.toLowerCase().includes(value),
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  filterPortNames(event: Event) {
    const value = (event?.target as HTMLInputElement)?.value?.trim().toLowerCase();
    if (value && this.ports) {
      this.portNameSuggestions = Object.keys(this.ports)
        .filter((port) => port.toLowerCase().includes(value))
        .map((port) => ({ port }));
    } else {
      this.portNameSuggestions = [];
    }
  }

  submitClick() {
    this.formSubmitted = true;
    console.log(this.requestForm.value);

    if (this.requestForm.invalid) {
      this.toastr.info(ToasterMessages.FormValidation);
      return;
    }
    const etdDate = this.requestForm.get('etdDate')?.value;
    const etdHours = this.requestForm.get('etdHours')?.value;
    const etdMinutes = this.requestForm.get('etdMinutes')?.value;

    const etaDate = this.requestForm.get('etaDate')?.value;
    const etaHours = this.requestForm.get('etahours')?.value;
    const etaMinutes = this.requestForm.get('etaMinutes')?.value;

    // --- Convert to ISO UTC format ---
    const etd = this.combineDateTimeToUTC(etdDate, etdHours, etdMinutes);
    const eta = this.combineDateTimeToUTC(etaDate, etaHours, etaMinutes);

    // --- Patch them into the main form controls ---
    this.requestForm.patchValue({
      etd: etd,
      eta: eta,
    });
    const formData = {
      ...this.requestForm.value,
      ...this.getViaPointsJson(),
    };
    console.log(formData);

    this.isSubmitting = true;
    this.toastr.info('Generating route advice report, please wait...', 'Processing Request');
    this.cdr.markForCheck();
    this.cdr.detectChanges();

    this.requestFormService.initialRouteAdvice(formData).subscribe({
      next: (data) => {
        this.isSubmitting = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        this.overlayService.showPdf(data);
        this.toastr.success('Route advice generated successfully!', 'Success');
      },
      error: async (error) => {
        this.isSubmitting = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        console.error('Error:', error);

        try {
          const errorText = await error.error.text();
          const errorJson = JSON.parse(errorText);

          this.toastr.error(errorJson.detail, 'Error');
        } catch (e) {
          this.toastr.error('Something went wrong. Please try again.', 'Error');
        }
      },
    });
  }
  /** Is the vessel already at sea? Strictly a boolean, whatever the form holds.
   *
   * The control is a checkbox so it normally carries true/false, but a form
   * repopulated from a saved request can arrive holding the STRING "true" or
   * "false". Both are truthy in Python's bool(), which is what the backend
   * uses, so "false" would quietly send a berthed vessel to sea — and the only
   * sign of it would be a hold priced and capped wrongly halfway through the
   * voyage. Resolve it here rather than hope.
   */
  isAtSea(): boolean {
    const v = this.requestForm.get('vesselAtSea')?.value;
    return v === true || v === 'true' || v === 1 || v === '1';
  }

  getViaPointsJson(): any {
    const result = this.viaPoints.map((keys) => {
      const lat = this.requestForm.get(keys.lat)?.value;
      const lon = this.requestForm.get(keys.lon)?.value;
      return { lat, lon };
    });

    return { viaPoints: result };
  }

  combineDateTimeToUTC(date: string, hours: number, minutes: number): string {
    if (!date) return '';

    // Pad hours and minutes to 2 digits
    const hh = (hours || 0).toString().padStart(2, '0');
    const mm = (minutes || 0).toString().padStart(2, '0');

    // Combine into ISO-like format
    return `${date}T${hh}:${mm}:00Z`;
  }
  combineDateTime(date: string, hours: number, minutes: number): string {
    if (!date) return '';

    const hh = (hours || 0).toString().padStart(2, '0');
    const mm = (minutes || 0).toString().padStart(2, '0');

    return `${date} ${hh}:${mm}`;
  }

  fetchClick() {
    const routeCoords: [number, number][] = [
      [18.94, 72.82], // Mumbai Port (Start)
      [17.5, 68.0], // Arabian Sea (Waypoint 1)
      [20.0, 63.5], // Near Oman Sea (Waypoint 2)
      [24.5, 56.5],
    ];

    // Draw route
    this.drawSeaRoute(routeCoords);

    // Add white circles for each route point
    this.addWhiteCircles(routeCoords);
  }

  private drawSeaRoute(coords: [number, number][]) {
    // Store coords for globe sync
    this.currentRouteCoords = coords;

    // Remove old route if exists
    if (this.routeLine) {
      this.routeLine.remove();
    }

    // Draw smooth blue polyline for route
    this.routeLine = L.polyline(coords, {
      color: 'dodgerblue',
      weight: 4,
      opacity: 0.8,
      smoothFactor: 1,
    }).addTo(this.map);

    // Zoom map to show full route
    this.map.fitBounds(this.routeLine.getBounds());

    // If globe is already initialized, sync route
    if (this.globeViewer) {
      this.drawRouteOnGlobe(coords);
    }
  }

  private addWhiteCircles(coords: [number, number][]) {
    coords.forEach((point) => {
      L.circleMarker(point, {
        radius: 6,
        color: '#0056b3', // border color
        fillColor: 'white', // fill color
        fillOpacity: 1, // solid fill
        weight: 1.5,
      }).addTo(this.map);
    });
  }

  // ─── Port & Waypoint Markers ──────────────────────────────────

  private updatePortMarkers(): void {
    if (!this.map || !(this.map as any)._panes) return;
    try {
      const startLat = parseFloat(this.requestForm.get('startLat')?.value);
      const startLon = parseFloat(this.requestForm.get('startLon')?.value);
      const endLat = parseFloat(this.requestForm.get('endLat')?.value);
      const endLon = parseFloat(this.requestForm.get('endLon')?.value);

      // --- Start port marker (green) ---
      if (!isNaN(startLat) && !isNaN(startLon)) {
        const startName = this.requestForm.get('startPortName')?.value || 'Start';
        if (this.startPortMarker) {
          this.startPortMarker.setLatLng([startLat, startLon]);
          this.startPortMarker.setTooltipContent(startName);
        } else {
          this.startPortMarker = L.circleMarker([startLat, startLon], {
            radius: 8,
            color: '#166534',
            fillColor: '#22c55e',
            fillOpacity: 1,
            weight: 2,
          })
            .bindTooltip(startName, {
              permanent: false,
              direction: 'top',
              offset: [0, -10],
            })
            .addTo(this.map);
        }
      }

      // --- End port marker (red) ---
      if (!isNaN(endLat) && !isNaN(endLon)) {
        const endName = this.requestForm.get('endPortName')?.value || 'End';
        if (this.endPortMarker) {
          this.endPortMarker.setLatLng([endLat, endLon]);
          this.endPortMarker.setTooltipContent(endName);
        } else {
          this.endPortMarker = L.circleMarker([endLat, endLon], {
            radius: 8,
            color: '#991b1b',
            fillColor: '#ef4444',
            fillOpacity: 1,
            weight: 2,
          })
            .bindTooltip(endName, {
              permanent: false,
              direction: 'top',
              offset: [0, -10],
            })
            .addTo(this.map);
        }
      }

      // --- Via point markers (orange) ---
      // Remove old via markers
      this.viaPointMarkers.forEach((m) => m.remove());
      this.viaPointMarkers = [];

      this.viaPoints.forEach((keys, i) => {
        const lat = parseFloat(this.requestForm.get(keys.lat)?.value);
        const lon = parseFloat(this.requestForm.get(keys.lon)?.value);
        if (!isNaN(lat) && !isNaN(lon)) {
          const marker = L.circleMarker([lat, lon], {
            radius: 6,
            color: '#92400e',
            fillColor: '#f59e0b',
            fillOpacity: 1,
            weight: 2,
          })
            .bindTooltip(`Via ${i + 1}`, {
              permanent: false,
              direction: 'top',
              offset: [0, -8],
            })
            .addTo(this.map);
          this.viaPointMarkers.push(marker);
        }
      });

      // Sync markers to 3D globe if active
      if (this.globeViewer) {
        this.updatePortMarkersOnGlobe();
      }
    } catch (e) {
      console.warn('updatePortMarkers error caught:', e);
    }
  }

  private updatePortMarkersOnGlobe(): void {
    if (!this.globeViewer) return;

    // Remove only port marker entities (tagged), keep route entities
    const toRemove: any[] = [];
    this.globeViewer.entities.values.forEach((e: any) => {
      if (e._portMarker) toRemove.push(e);
    });
    toRemove.forEach((e: any) => this.globeViewer.entities.remove(e));

    const addGlobeMarker = (
      lat: number,
      lon: number,
      label: string,
      color: string,
      size: number,
    ) => {
      const entity = this.globeViewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(lon, lat),
        point: {
          pixelSize: size,
          color: Cesium.Color.fromCssColorString(color),
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 2,
        },
        label: {
          text: label,
          font: '12px sans-serif',
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -14),
        },
      });
      entity._portMarker = true; // tag for selective removal
    };

    const startLat = parseFloat(this.requestForm.get('startLat')?.value);
    const startLon = parseFloat(this.requestForm.get('startLon')?.value);
    if (!isNaN(startLat) && !isNaN(startLon)) {
      const name = this.requestForm.get('startPortName')?.value || 'Start';
      addGlobeMarker(startLat, startLon, name, '#22c55e', 12);
    }

    const endLat = parseFloat(this.requestForm.get('endLat')?.value);
    const endLon = parseFloat(this.requestForm.get('endLon')?.value);
    if (!isNaN(endLat) && !isNaN(endLon)) {
      const name = this.requestForm.get('endPortName')?.value || 'End';
      addGlobeMarker(endLat, endLon, name, '#ef4444', 12);
    }

    this.viaPoints.forEach((keys, i) => {
      const lat = parseFloat(this.requestForm.get(keys.lat)?.value);
      const lon = parseFloat(this.requestForm.get(keys.lon)?.value);
      if (!isNaN(lat) && !isNaN(lon)) {
        addGlobeMarker(lat, lon, `Via ${i + 1}`, '#f59e0b', 9);
      }
    });
  }

  // Fly the active view (2D or 3D) to a point
  private flyToPoint(lat: number, lon: number): void {
    if (lat == null || lon == null || isNaN(lat) || isNaN(lon)) return;

    if (this.isGlobeMode && this.globeViewer) {
      try {
        this.globeViewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(lon, lat, 3000000),
          duration: 1.2,
        });
      } catch (e) {}
    } else if (this.map && (this.map as any)._panes) {
      try {
        this.map.flyTo([lat, lon], 6, { duration: 1.0 });
      } catch (e) {}
    }
  }


  enableLocationSelect(latControlName: string, lonControlName: string): void {
    this.locationSelectionEnabled = true;
    this.toastr.warning('Click on the map to select coordinates.');

    // Remove any old listeners before adding a new one
    this.map.off('click');
    this.map.on('click', (e: L.LeafletMouseEvent) =>
      this.onMapClick(e, latControlName, lonControlName),
    );
  }

  onMapClick(
    e: L.LeafletMouseEvent,
    latControlName: string,
    lonControlName: string,
  ): void {
    if (!this.locationSelectionEnabled) return;

    const { lat, lng } = e.latlng;

    // ✅ Dynamically update form controls using computed keys
    this.requestForm.patchValue({
      [latControlName]: lat.toFixed(6),
      [lonControlName]: lng.toFixed(6),
    });

    const pinIcon = L.icon({
      iconUrl: '../../../../../assets/images/pin_icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    // Add or move marker
    if (this.marker) {
      this.marker.setLatLng([lat, lng]);
    } else {
      this.marker = L.marker([lat, lng], { icon: pinIcon }).addTo(this.map);
    }

    this.locationSelectionEnabled = false;
    this.map.off('click');
    this.updatePortMarkers();
    this.flyToPoint(lat, lng);
  }

  addViaPoint(): void {
    const index = this.viaPoints.length + 1;
    const latKey = `viaLat_${index}`;
    const lonKey = `viaLon_${index}`;

    this.viaPoints.push({ lat: latKey, lon: lonKey });

    // Dynamically add controls to form
    this.requestForm.addControl(latKey, this.fb.control(''));
    this.requestForm.addControl(lonKey, this.fb.control(''));

    // Watch for changes on via point coords
    this.requestForm
      .get(latKey)
      ?.valueChanges.subscribe(() => this.updatePortMarkers());
    this.requestForm.get(lonKey)?.valueChanges.subscribe(() => {
      this.updatePortMarkers();
      // Fly to via point when both coords are valid
      const lat = parseFloat(this.requestForm.get(latKey)?.value);
      const lon = parseFloat(this.requestForm.get(lonKey)?.value);
      if (!isNaN(lat) && !isNaN(lon)) {
        this.flyToPoint(lat, lon);
      }
    });
  }

  /** Remove a row + its controls */
  removeViaPoint(index: number): void {
    const keys = this.viaPoints[index];
    this.requestForm.removeControl(keys.lat);
    this.requestForm.removeControl(keys.lon);
    this.viaPoints.splice(index, 1);
    this.updatePortMarkers();
  }

  filterPorts(): void {
    const searchValue =
      this.requestForm.get('startPortName')?.value?.toLowerCase() || '';

    // 1️⃣ Remove duplicates using a Map (keyed by name)
    const uniquePorts = Array.from(
      new Map(
        this.ports.map((p: any) => [p.properties.name.toLowerCase(), p]),
      ).values(),
    );

    // 2️⃣ Sort alphabetically by name
    const sortedPorts = uniquePorts.sort((a: any, b: any) =>
      a.properties.name.localeCompare(b.properties.name),
    );

    // 3️⃣ Filter ports that start with the entered letter(s)
    this.filteredPorts = sortedPorts.filter((p: any) =>
      p.properties.name.toLowerCase().startsWith(searchValue),
    );
  }

  onPortSelected(selectedName: string): void {
    const selectedPort = this.ports.find(
      (p: { properties: { name: string } }) =>
        p.properties.name === selectedName,
    );
    if (selectedPort) {
      this.requestForm.patchValue({
        startPortId: selectedPort.properties.id,
      });
      // Start coordinates must always be the vessel's current AIS position, not the start port coordinates
      const imo = this.requestForm.get('imo')?.value;
      if (imo) {
        this.getAisPosition(imo);
      }
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }
  }
  filterEndPorts(): void {
    const searchValue =
      this.requestForm.get('endPortName')?.value?.toLowerCase() || '';

    // 1️⃣ Remove duplicate port names (case-insensitive)
    const uniquePorts = Array.from(
      new Map(
        this.ports.map((p: any) => [p.properties.name.toLowerCase(), p]),
      ).values(),
    );

    // 2️⃣ Sort ports alphabetically by name
    const sortedPorts = uniquePorts.sort((a: any, b: any) =>
      a.properties.name.localeCompare(b.properties.name),
    );

    // 3️⃣ Filter ports that start with the entered text
    this.filteredEndPorts = sortedPorts.filter((p: any) =>
      p.properties.name.toLowerCase().startsWith(searchValue),
    );
  }

  onEndPortSelected(selectedName: string): void {
    const selectedPort = this.ports.find(
      (p: { properties: { name: string } }) =>
        p.properties.name === selectedName,
    );
    if (selectedPort) {
      const [lon, lat] = selectedPort.geometry.coordinates;
      this.requestForm.patchValue({
        endPortId: selectedPort.properties.id,
        endLat: lat.toFixed(6),
        endLon: lon.toFixed(6),
      });
      this.updatePortMarkers();
      this.flyToPoint(lat, lon);
    }
  }
  isRouteCsvUploaded(): boolean {
    if (this.isMultiRouteComp) {
      const hasRoute1 = !!(this.uploadedFiles[0] || (this.uploadedRoutePoints1 && this.uploadedRoutePoints1.length > 0));
      const hasRoute2 = !!(this.uploadedFiles[1] || (this.uploadedRoutePoints2 && this.uploadedRoutePoints2.length > 0));
      return hasRoute1 && hasRoute2;
    }
    return !!(this.uploadedFile || (this.uploadedRoutePoints && this.uploadedRoutePoints.length > 0));
  }

  jupiterSubmitClick() {
    this.formSubmitted = true;

    if (this.isMultiRouteComp) {
      if (!this.uploadedFiles[0] && (!this.uploadedRoutePoints1 || this.uploadedRoutePoints1.length === 0)) {
        this.toastr.warning('Please upload Route 1 CSV/Excel file before submitting', 'Route Required');
        return;
      }
      if (!this.uploadedFiles[1] && (!this.uploadedRoutePoints2 || this.uploadedRoutePoints2.length === 0)) {
        this.toastr.warning('Please upload Route 2 CSV/Excel file before submitting', 'Route Required');
        return;
      }
    } else {
      if (!this.uploadedFile && (!this.uploadedRoutePoints || this.uploadedRoutePoints.length === 0)) {
        this.toastr.warning('Route CSV/Excel file is mandatory. Please upload a CSV/Excel file before submitting.', 'Route Required');
        return;
      }
    }
    const etdDate = this.requestForm.get('etdDate')?.value;
    const etdHours = this.requestForm.get('etdHours')?.value;
    const etdMinutes = this.requestForm.get('etdMinutes')?.value;
    const etd = this.combineDateTime(etdDate, etdHours, etdMinutes);
    const etaDate = this.requestForm.get('etaDate')?.value;
    const etaHours = this.requestForm.get('etahours')?.value;
    const etaMinutes = this.requestForm.get('etaMinutes')?.value;
    const eta = this.combineDateTimeToUTC(etaDate, etaHours, etaMinutes);
    this.requestForm.patchValue({
      etd: etd,
      eta: eta,
    });
    const formData = {
      vesselName: this.requestForm.get('vesselName')?.value,
      vesselType: this.requestForm.get('vesselType')?.value,
      imo: this.requestForm.get('imo')?.value,
      yearBuilt: this.requestForm.get('yearBuilt')?.value,

      startPortName: this.requestForm.get('startPortName')?.value,
      startPortId: this.requestForm.get('startPortId')?.value,
      startLat: this.requestForm.get('startLat')?.value,
      startLon: this.requestForm.get('startLon')?.value,

      endPortName: this.requestForm.get('endPortName')?.value,
      endPortId: this.requestForm.get('endPortId')?.value,
      endLat: this.requestForm.get('endLat')?.value,
      endLon: this.requestForm.get('endLon')?.value,

      timeBetwPoints: this.requestForm.get('timeBetwPoints')?.value,
      speed: this.isRouteComp || this.isMultiRouteComp
        ? this.requestForm.get('routeComparisons')?.value.map((item: any) => item.speed)
        : this.requestForm.get('speed')?.value,

      consumption: this.isRouteComp || this.isMultiRouteComp
        ? this.requestForm.get('routeComparisons')?.value.map((item: any) => item.consumption)
        : this.requestForm.get('consumption')?.value,

      fuel_cost_per_mt: this.isRouteComp || this.isMultiRouteComp
        ? this.requestForm.get('routeComparisons')?.value.map((item: any) => item.fuel_cost_per_mt)
        : this.requestForm.get('fuel_cost_per_mt')?.value,

      vessel_cost_per_day: this.isRouteComp || this.isMultiRouteComp
        ? this.requestForm.get('routeComparisons')?.value.map((item: any) => item.vessel_cost_per_day)
        : this.requestForm.get('vessel_cost_per_day')?.value,
      // Laden / Ballast. Was sent from the weatherForcRange box by mistake,
      // so the backend never saw the loading condition.
      condition: this.requestForm.get('condition')?.value,
      weatherForcRange: this.requestForm.get('weatherForcRange')?.value,
      timeBckInHours: this.requestForm.get('timeBckInHours')?.value,

      ship_length: this.requestForm.get('ship_length')?.value,
      ship_breadth: this.requestForm.get('ship_breadth')?.value,

      wind_drag_coefficient: this.requestForm.get('wind_drag_coefficient')
        ?.value,
      air_density: this.requestForm.get('air_density')?.value,
      empirical_constant: this.requestForm.get('empirical_constant')?.value,
      power_inp: this.requestForm.get('power_inp')?.value,

      windage_area: this.requestForm.get('windage_area')?.value,
      etd: this.requestForm.get('etd')?.value,
      eta: this.requestForm.get('eta')?.value,
      speed_min: Number(this.requestForm.get('minSpeed')?.value),

      speed_max: Number(this.requestForm.get('maxSpeed')?.value),
      rough_wave_h: Number(this.requestForm.get('rough_wave_h')?.value),

      rough_wind_spd: Number(this.requestForm.get('rough_wind_spd')?.value),

      moderate_wave_h: Number(this.requestForm.get('moderate_wave_h')?.value),

      moderate_wind: Number(this.requestForm.get('moderate_wind')?.value),
      report_type: this.selectedType,
      hire_cost_per_day:this.requestForm.get('hire_cost_per_day')?.value,
      strom_BF:this.requestForm.get('strom_BF')?.value,
      wait_hours:this.requestForm.get('wait_hours')?.value,
      speed_margin:this.requestForm.get('speed_margin')?.value,
      fc_speed1:this.requestForm.get('fc_speed1')?.value,
      fc_consumption1:this.requestForm.get('fc_consumption1')?.value,
      fc_speed2:this.requestForm.get('fc_speed2')?.value,
      fc_consumption2:this.requestForm.get('fc_consumption2')?.value,
      stop_wind_kn:this.requestForm.get('stop_wind_kn')?.value,
      stop_fuel_rate:this.requestForm.get('stop_fuel_rate')?.value,
      draft: this.requestForm.get('draft')?.value,
      fuelSource: this.fuelSourceValues[this.requestForm.get('fuelSource')?.value] || 'auto',
      calmWaterMethod: this.fuelMethodValues[this.requestForm.get('calmWaterMethod')?.value] || 'screen_3m',
      // Sent as a real boolean, never a string. The backend reads this with
      // bool(), and bool("false") is True in Python — so a saved form that
      // came back as the STRING "false" would put a vessel to sea that is
      // sitting at a berth, and the only visible symptom would be a hold
      // priced wrongly somewhere in the middle of the voyage.
      vesselAtSea: this.isAtSea(),
      // Blank is fine: the engine falls back to its own 32 nm default.
      driftRadiusNm: this.requestForm.get('driftRadiusNm')?.value,
      // ✅ via points
      ...this.getViaPointsJson(),

      // ✅ multi-route comparison flag
      ...(this.isMultiRouteComp ? { route_comparison_with_csv: true } : {}),
      ...(this.isRouteComp ? { 'route-comparison': true } : {}),
    };
    const waypoints = this.isMultiRouteComp
      ? [
        this.uploadedRoutePoints1.map((p: any) => ({
          GC_Distance_NM: Number(p.GC_Distance_NM || 0),
          LAT: Number(p.LAT),
          LONG: Number(p.LONG),
          RL_Distance_NM: Number(p.RL_Distance_NM || 0),
          'Sail(RL/GC)': p['Sail(RL/GC)'] || 'RL',
          Total_GC_NM: Number(p.Total_GC_NM || 0),
          Total_RL_NM: Number(p.Total_RL_NM || 0),
          WPT_No: Number(p.WPT_No),
          flag: p.flag || 'existing',
        })),
        this.uploadedRoutePoints2.map((p: any) => ({
          GC_Distance_NM: Number(p.GC_Distance_NM || 0),
          LAT: Number(p.LAT),
          LONG: Number(p.LONG),
          RL_Distance_NM: Number(p.RL_Distance_NM || 0),
          'Sail(RL/GC)': p['Sail(RL/GC)'] || 'RL',
          Total_GC_NM: Number(p.Total_GC_NM || 0),
          Total_RL_NM: Number(p.Total_RL_NM || 0),
          WPT_No: Number(p.WPT_No),
          flag: p.flag || 'existing',
        })),
      ]
      : this.uploadedRoutePoints.map((p: any) => ({
        GC_Distance_NM: Number(p.GC_Distance_NM || 0),
        LAT: Number(p.LAT),
        LONG: Number(p.LONG),
        RL_Distance_NM: Number(p.RL_Distance_NM || 0),
        'Sail(RL/GC)': p['Sail(RL/GC)'] || 'RL',
        Total_GC_NM: Number(p.Total_GC_NM || 0),
        Total_RL_NM: Number(p.Total_RL_NM || 0),
        WPT_No: Number(p.WPT_No),
        flag: p.flag || 'existing',
      }));
    const files = this.isMultiRouteComp
      ? this.uploadedFiles
      : this.uploadedFile;

    this.simulationError = null;
    this.isSubmitting = true;
    this.toastr.info('Generating route simulation report, please wait...', 'Processing Simulation');
    this.cdr.markForCheck();
    this.cdr.detectChanges();

    this.requestFormService
      .simulationReport(formData, files, waypoints)
      .subscribe({
        next: (res) => {
          this.isSubmitting = false;
          this.simulationError = null;
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          this.overlayService.showPdf(res);
          this.toastr.success('Simulation report generated successfully!', 'Success');
        },
        error: (err) => {
          this.isSubmitting = false;
          let detail = err?.error?.detail || err?.error?.details || err?.error?.error || err?.error?.message || err?.message || 'Failed to generate report';
          if (typeof detail === 'object') {
            try { detail = JSON.stringify(detail, null, 2); } catch { detail = String(detail); }
          }
          this.simulationError = detail;
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          this.toastr.error(detail, 'Simulation Report Error', { timeOut: 20000, closeButton: true, enableHtml: true });
          setTimeout(() => {
            const el = document.getElementById('simulation-error-banner-bottom') || document.getElementById('simulation-error-banner-top');
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 100);
        },
      });
  }

  uploadedFile: any;

  onFileUpload(event: any, routeIndex?: number) {
    const file = event.target.files[0];

    if (!file) return;

    const fileType = file.name.split('.').pop()?.toLowerCase();

    if (!['csv', 'xlsx', 'xls'].includes(fileType || '')) {
      this.toastr.error('Only CSV or Excel files are allowed');
      return;
    }

    this.uploadedFile = file;
    if (this.isMultiRouteComp && routeIndex) {
      this.uploadedFiles[routeIndex - 1] = file;
    }
    this.uploadRouteFile(file, routeIndex);
  }
  uploadedFiles: File[] = [];
  uploadedRoutePoints1: any[] = [];
  uploadedRoutePoints2: any[] = [];
  uploadedRouteMarkers1: any[] = [];
  uploadedRouteMarkers2: any[] = [];
  uploadRouteFile(file: File, routeIndex?: number) {
    this.requestFormService.getCsvWaypoints(file).subscribe({
      next: (res: any) => {
        const waypoints = res.waypoints || [];
        if (!this.isMultiRouteComp) {
          // Existing single route functionality
          this.uploadedRoutePoints = waypoints;
          this.recalculateWaypointDistances(this.uploadedRoutePoints);
          this.drawUploadedRoute(this.uploadedRoutePoints, true);

          this.toastr.success('Route uploaded successfully');
          return;
        }

        if (routeIndex === 1) {
          this.uploadedRoute1 = waypoints;
          this.uploadedRoutePoints1 = res.waypoints || [];
          this.recalculateWaypointDistances(this.uploadedRoutePoints1);

          // Existing function
          this.drawUploadedRoute(this.uploadedRoutePoints1, true);

          this.toastr.success('Route 1 uploaded successfully');
        }

        if (routeIndex === 2) {
          this.uploadedRoute2 = waypoints;
          this.uploadedRoutePoints2 = res.waypoints || [];
          this.recalculateWaypointDistances(this.uploadedRoutePoints2);

          // New second route function
          this.drawSecondUploadedRoute(this.uploadedRoutePoints2, true);

          this.toastr.success('Route 2 uploaded successfully');
        }
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Failed to upload route');
      },
    });
  }
  // fitView should only be true when a route is first loaded. Redraws caused by
  // user edits (drag, add/remove waypoint, lat/lng change) must keep the
  // current zoom/pan so the map is only moved by the user.
  drawSecondUploadedRoute(points: any[], fitView: boolean = false) {
    if (this.secondRouteLayer) {
      this.map.removeLayer(this.secondRouteLayer);
      this.secondRouteLayer = null;
    }

    if (this.secondRouteMarkersLayer) {
      this.map.removeLayer(this.secondRouteMarkersLayer);
      this.secondRouteMarkersLayer = null;
    }

    this.uploadedRouteMarkers2 = [];

    if (!points || points.length === 0) return;

    const routePoints = points.map((p) => ({
      lat: Number(p.LAT),
      lng: Number(p.LONG),
      flag: p.flag || 'existing',
      ...p,
    }));

    const normalizedPoints = this.normalizeRoute(routePoints);

    const latlngs = normalizedPoints.map((p) => [p.lat, p.lng]);

    this.secondRouteLayer = L.polyline(latlngs, {
      color: 'red',
      weight: 4,
    }).addTo(this.map);

    this.secondRouteMarkersLayer = L.layerGroup().addTo(this.map);

    normalizedPoints.forEach((p: any, idx: number) => {
      const marker = L.marker([p.lat, p.lng], {
        draggable: true,
        zIndexOffset: 1000, // always on top of Route 1 markers
        icon: L.divIcon({
          className: 'route-waypoint-marker',
          html: `<div class="marker-dot-label route-2-dot">${p.WPT_No}</div>`,
          iconSize: [22, 22],
          iconAnchor: [11, 11]
        })
      });

      marker.bindTooltip(
        `
      <div>
        <b>Waypoint:</b> ${p.WPT_No}<br>
        <b>Flag:</b> ${p.flag}<br>
        <b>Lat:</b> ${Number(p.originalLat ?? p.lat).toFixed(5)}<br>
        <b>Lng:</b> ${Number(p.originalLng ?? p.lng).toFixed(5)}
      </div>
      `,
        {
          direction: 'top',
          sticky: true,
        }
      );

      // Click to scroll to card and highlight
      marker.on('click', () => {
        this.scrollToCard(2, idx);
      });

      // Hover linking to card
      marker.on('mouseover', () => {
        this.hoveredCardId = `route2-card-${idx}`;
      });

      marker.on('mouseout', () => {
        this.hoveredCardId = null;
      });

      // Right-click to delete waypoint
      marker.on('contextmenu', (e: any) => {
        if (e.originalEvent) {
          e.originalEvent.preventDefault();
          e.originalEvent.stopPropagation();
        }
        this.removeRow(idx, points);
      });

      // Drag events for live polyline updates
      marker.on('drag', (e: any) => {
        const newPos = e.latlng;
        const pt = points[idx];
        if (pt) {
          pt.LAT = newPos.lat.toFixed(6);
          pt.LONG = newPos.lng.toFixed(6);
          pt.originalLat = newPos.lat;
          pt.originalLng = newPos.lng;
        }

        const updatedLatLngs = points.map((pPt: any) => [Number(pPt.LAT), Number(pPt.LONG)]);
        this.secondRouteLayer.setLatLngs(updatedLatLngs);
      });

      marker.on('dragend', (e: any) => {
        const newPos = e.target.getLatLng();
        const pt = points[idx];
        if (pt) {
          pt.LAT = Number(newPos.lat.toFixed(6));
          pt.LONG = Number(newPos.lng.toFixed(6));
          pt.originalLat = pt.LAT;
          pt.originalLng = pt.LONG;
        }

        this.recalculateWaypointDistances(points);
        this.drawSecondUploadedRoute(points);
      });

      marker.addTo(this.secondRouteMarkersLayer);
      this.uploadedRouteMarkers2.push(marker);
    });

    if (fitView) {
      const layers = [this.routeLayer, this.secondRouteLayer].filter(Boolean);
      if (layers.length > 0) {
        const group = L.featureGroup(layers);
        this.map.fitBounds(group.getBounds(), {
          padding: [20, 20],
        });
      }
    }
  }
  fetchAllVessels() {
    this.sharedDataService.getLookerVessels(this.username, { active_only: true, exclude_zeronorth: true }).subscribe({
      next: (res: any) => {
        const list = res || [];
        this.vessels = list.filter((v: any) => {
          const isActive = v.vessel_status === 'Active' || v.isactive === true;
          const isZeroNorth = (v.client_name || '').toLowerCase().includes('zeronorth');
          return isActive && !isZeroNorth;
        });
      },
      error: (err) => {
        console.error('Failed to load vessels', err);
      },
    });
  }

  fetchUploadRouteClick() { }
  submitUploadRouteClick() {
    if (!this.uploadedFile && (!this.uploadedRoutePoints || this.uploadedRoutePoints.length === 0)) {
      this.toastr.warning('Route CSV/Excel file is mandatory. Please upload a CSV/Excel file before submitting.', 'Route Required');
      return;
    }
    const vesselName = this.requestForm.get('vesselName')?.value;
    const imo = this.requestForm.get('imo')?.value;
    const waypoints = this.uploadedRoutePoints.map((p: any) => ({
      GC_Distance_NM: Number(p.GC_Distance_NM || 0),

      LAT: Number(p.LAT),

      LONG: Number(p.LONG),

      RL_Distance_NM: Number(p.RL_Distance_NM || 0),

      'Sail(RL/GC)': p['Sail(RL/GC)'] || 'RL',

      Total_GC_NM: Number(p.Total_GC_NM || 0),

      Total_RL_NM: Number(p.Total_RL_NM || 0),

      WPT_No: Number(p.WPT_No),
      flag: p.flag || 'existing',
    }));

    console.log('Waypoints Payload:', waypoints);
    this.requestFormService
      .csvRoute(imo, vesselName, this.uploadedFile, waypoints)
      .subscribe(
        (res) => {
          if (res.error) {
            this.toastr.error('Error uploading CSV route:', res.error);
            return;
          } else {
            this.toastr.success(res.message);
          }
        },
        (err) => {
          this.toastr.error('Error uploading CSV route:', err);
        },
      );
  }

  addRow(index: number, routePoints: any[]) {
    const current = routePoints[index];
    let lat = Number(current.LAT);
    let long = Number(current.LONG);

    if (index + 1 < routePoints.length) {
      const next = routePoints[index + 1];
      lat = (Number(current.LAT) + Number(next.LAT)) / 2;

      let currentLong = Number(current.LONG);
      let nextLong = Number(next.LONG);

      // Handle antimeridian wrap-around for midpoint interpolation
      if (Math.abs(currentLong - nextLong) > 180) {
        if (currentLong < 0) {
          currentLong += 360;
        } else {
          nextLong += 360;
        }
      }

      long = (currentLong + nextLong) / 2;
      if (long > 180) {
        long -= 360;
      } else if (long < -180) {
        long += 360;
      }
    } else if (index > 0) {
      const prev = routePoints[index - 1];
      const prevLat = Number(prev.LAT);
      let prevLong = Number(prev.LONG);
      let currentLong = Number(current.LONG);

      lat = lat + (lat - prevLat) * 0.5;

      // Handle wrap-around for collinear projection
      if (Math.abs(currentLong - prevLong) > 180) {
        if (currentLong < 0) {
          currentLong += 360;
        } else {
          prevLong += 360;
        }
      }

      long = currentLong + (currentLong - prevLong) * 0.5;
      if (long > 180) {
        long -= 360;
      } else if (long < -180) {
        long += 360;
      }
    } else {
      // Offset by constant if only one point exists
      lat = lat + 0.1;
      long = long + 0.1;
    }

    const newPoint = {
      GC_Distance_NM: 0,
      LAT: Number(lat.toFixed(6)),
      LONG: Number(long.toFixed(6)),
      RL_Distance_NM: 0,
      'Sail(RL/GC)': 'RL',
      Total_GC_NM: 0,
      Total_RL_NM: 0,
      WPT_No: index + 2,
      isAdded: true,
      flag: 'manual',
    };

    routePoints.splice(index + 1, 0, newPoint);

    routePoints.forEach((p) => {
      p.flag = p.flag || 'existing';
    });

    this.updateWaypointNumbers(routePoints);
    this.recalculateWaypointDistances(routePoints);

    if (routePoints === this.uploadedRoutePoints) {
      this.drawUploadedRoute(routePoints);
    } else if (routePoints === this.uploadedRoutePoints1) {
      this.drawUploadedRoute(routePoints);
    } else if (routePoints === this.uploadedRoutePoints2) {
      this.drawSecondUploadedRoute(routePoints);
    } else {
      this.drawUploadedRoute(routePoints);
    }
  }

  removeRow(index: number, routePoints: any[]) {
    routePoints.splice(index, 1);

    this.updateWaypointNumbers(routePoints);
    this.recalculateWaypointDistances(routePoints);

    if (routePoints === this.uploadedRoutePoints) {
      this.drawUploadedRoute(routePoints);
    } else if (routePoints === this.uploadedRoutePoints1) {
      this.drawUploadedRoute(routePoints);
    } else if (routePoints === this.uploadedRoutePoints2) {
      this.drawSecondUploadedRoute(routePoints);
    } else {
      this.drawUploadedRoute(routePoints);
    }
  }

  updateWaypointNumbers(routePoints: any[]) {
    routePoints.forEach((p, i) => {
      p.WPT_No = i;
    });
  }

  // See drawSecondUploadedRoute: fitView only on first load of a route.
  drawUploadedRoute(points: any[], fitView: boolean = false) {
    if (this.routeLayer) {
      this.map.removeLayer(this.routeLayer);
      this.routeLayer = null;
    }

    if (this.routeMarkersLayer) {
      this.map.removeLayer(this.routeMarkersLayer);
      this.routeMarkersLayer = null;
    }

    const isMulti = this.isMultiRouteComp;
    if (isMulti) {
      this.uploadedRouteMarkers1 = [];
    } else {
      this.uploadedRouteMarkers = [];
    }

    if (!points || points.length === 0) return;

    // Convert uploaded points
    const routePoints = points.map((p) => ({
      lat: Number(p.LAT),
      lng: Number(p.LONG),
      flag: p.flag || 'existing',
      ...p,
    }));

    // Normalize route
    const normalizedPoints = this.normalizeRoute(routePoints);

    // Draw route line
    const latlngs = normalizedPoints.map((p) => [p.lat, p.lng]);

    this.routeLayer = L.polyline(latlngs, {
      color: 'blue',
      weight: 4,
    }).addTo(this.map);

    this.routeMarkersLayer = L.layerGroup().addTo(this.map);

    // Add waypoint markers
    normalizedPoints.forEach((p: any, idx: number) => {
      const dotClass = isMulti ? 'route-1-dot' : 'single-route-dot';

      const marker = L.marker([p.lat, p.lng], {
        draggable: true,
        zIndexOffset: isMulti ? 500 : 800,
        icon: L.divIcon({
          className: 'route-waypoint-marker',
          html: `<div class="marker-dot-label ${dotClass}">${p.WPT_No}</div>`,
          iconSize: [22, 22],
          iconAnchor: [11, 11]
        })
      });

      marker.bindTooltip(
        `
      <div>
        <b>Waypoint:</b> ${p.WPT_No}<br>
        <b>Flag:</b> ${p.flag}<br>
        <b>Lat:</b> ${Number(p.originalLat ?? p.lat).toFixed(5)}<br>
        <b>Lng:</b> ${Number(p.originalLng ?? p.lng).toFixed(5)}
      </div>
      `,
        {
          direction: 'top',
          sticky: true,
        },
      );

      // Click to scroll to card and highlight
      marker.on('click', () => {
        this.scrollToCard(isMulti ? 1 : 0, idx);
      });

      // Hover linking to card
      marker.on('mouseover', () => {
        this.hoveredCardId = isMulti ? `route1-card-${idx}` : `route-card-${idx}`;
      });

      marker.on('mouseout', () => {
        this.hoveredCardId = null;
      });

      // Right-click to delete waypoint
      marker.on('contextmenu', (e: any) => {
        if (e.originalEvent) {
          e.originalEvent.preventDefault();
          e.originalEvent.stopPropagation();
        }
        this.removeRow(idx, points);
      });

      // Drag events for live polyline updates
      marker.on('drag', (e: any) => {
        const newPos = e.latlng;
        const pt = points[idx];
        if (pt) {
          pt.LAT = newPos.lat.toFixed(6);
          pt.LONG = newPos.lng.toFixed(6);
          pt.originalLat = newPos.lat;
          pt.originalLng = newPos.lng;
        }

        const updatedLatLngs = points.map((pPt: any) => [Number(pPt.LAT), Number(pPt.LONG)]);
        this.routeLayer.setLatLngs(updatedLatLngs);
      });

      marker.on('dragend', (e: any) => {
        const newPos = e.target.getLatLng();
        const pt = points[idx];
        if (pt) {
          pt.LAT = Number(newPos.lat.toFixed(6));
          pt.LONG = Number(newPos.lng.toFixed(6));
          pt.originalLat = pt.LAT;
          pt.originalLng = pt.LONG;
        }

        this.recalculateWaypointDistances(points);
        this.drawUploadedRoute(points);
      });

      marker.addTo(this.routeMarkersLayer);
      if (isMulti) {
        this.uploadedRouteMarkers1.push(marker);
      } else {
        this.uploadedRouteMarkers.push(marker);
      }
    });

    if (fitView) {
      const layers = [this.routeLayer, this.secondRouteLayer].filter(Boolean);
      if (layers.length > 0) {
        const group = L.featureGroup(layers);
        this.map.fitBounds(group.getBounds(), {
          padding: [20, 20],
        });
      }
    }
  }

  normalizeRoute(points: any[], anchorLng?: number): any[] {
    if (!points || points.length === 0) return points;

    const result = [];

    let firstPoint = {
      ...points[0],
      originalLng: points[0].lng !== undefined ? points[0].lng : points[0].lon,
      originalLat: points[0].lat,
    };

    let firstLng =
      firstPoint.lng !== undefined
        ? firstPoint.lng
        : firstPoint.lon !== undefined
          ? firstPoint.lon
          : undefined;

    if (
      anchorLng !== undefined &&
      anchorLng !== null &&
      !isNaN(anchorLng) &&
      firstLng !== undefined
    ) {
      const shift = Math.round((anchorLng - firstLng) / 360) * 360;

      if (shift !== 0) {
        firstLng += shift;

        if (firstPoint.lng !== undefined) firstPoint.lng = firstLng;
        if (firstPoint.lon !== undefined) firstPoint.lon = firstLng;
      }
    }

    result.push(firstPoint);

    for (let i = 1; i < points.length; i++) {
      let prev = result[i - 1];

      let curr = {
        ...points[i],
        originalLng:
          points[i].lng !== undefined ? points[i].lng : points[i].lon,
        originalLat: points[i].lat,
      };

      let prevLng = prev.lng !== undefined ? prev.lng : prev.lon;
      let currLng = curr.lng !== undefined ? curr.lng : curr.lon;

      if (prevLng !== undefined && currLng !== undefined) {
        let diff = currLng - prevLng;

        if (diff > 180) {
          if (curr.lng !== undefined) curr.lng -= 360;
          if (curr.lon !== undefined) curr.lon -= 360;
        } else if (diff < -180) {
          if (curr.lng !== undefined) curr.lng += 360;
          if (curr.lon !== undefined) curr.lon += 360;
        }
      }

      result.push(curr);
    }

    return result;
  }

  enableWaypointLocationSelect(point: any, routePoints: any[]) {
    this.selectedWaypointPoint = point;

    this.toastr.info('Move mouse on map and click to select waypoint');

    // =====================================================
    // Remove old listeners
    // =====================================================

    if (this.mapClickListener) {
      this.map.off('click', this.mapClickListener);
    }

    if (this.mapMouseMoveListener) {
      this.map.off('mousemove', this.mapMouseMoveListener);
    }

    // Remove old tooltip
    if (this.mapHoverTooltip) {
      this.map.removeLayer(this.mapHoverTooltip);
    }

    // =====================================================
    // Create floating tooltip
    // =====================================================

    this.mapHoverTooltip = L.tooltip({
      permanent: false,
      direction: 'top',
      offset: [0, -10],
      opacity: 0.9,
    });

    // =====================================================
    // Mouse move event
    // =====================================================

    this.mapMouseMoveListener = (e: any) => {
      const lat = Number(e.latlng.lat.toFixed(6));

      let lng = Number(e.latlng.lng.toFixed(6));

      // Convert normalized longitude back
      if (lng > 180) {
        lng -= 360;
      } else if (lng < -180) {
        lng += 360;
      }

      const content = `
      <div>
        <b>Lat:</b> ${lat}<br/>
        <b>Lng:</b> ${lng}
      </div>
    `;

      this.mapHoverTooltip.setLatLng(e.latlng).setContent(content);

      if (!this.map.hasLayer(this.mapHoverTooltip)) {
        this.mapHoverTooltip.addTo(this.map);
      }
    };

    // =====================================================
    // Click event
    // =====================================================

    this.mapClickListener = (e: any) => {
      const lat = Number(e.latlng.lat.toFixed(6));

      let lng = Number(e.latlng.lng.toFixed(6));

      // Convert normalized longitude back
      if (lng > 180) {
        lng -= 360;
      } else if (lng < -180) {
        lng += 360;
      }

      // Update waypoint
      point.LAT = lat;
      point.LONG = lng;

      point.originalLat = lat;
      point.originalLng = lng;

      // Recalculate distances
      this.recalculateWaypointDistances(routePoints);

      if (routePoints === this.uploadedRoutePoints1) {
        this.drawUploadedRoute(routePoints);
      } else if (routePoints === this.uploadedRoutePoints2) {
        this.drawSecondUploadedRoute(routePoints);
      } else {
        this.drawUploadedRoute(routePoints); // single route mode
      }

      this.toastr.success('Waypoint updated from map');

      // =====================================================
      // Cleanup
      // =====================================================

      this.map.off('click', this.mapClickListener);
      this.map.off('mousemove', this.mapMouseMoveListener);

      if (this.mapHoverTooltip) {
        this.map.removeLayer(this.mapHoverTooltip);
      }

      this.mapClickListener = null;
      this.mapMouseMoveListener = null;
      this.mapHoverTooltip = null;

      this.selectedWaypointPoint = null;
    };

    // =====================================================
    // Enable events
    // =====================================================

    this.map.on('mousemove', this.mapMouseMoveListener);

    this.map.on('click', this.mapClickListener);
  }

  toRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  gcDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 3440.065; // Nautical Miles

    lat1 = this.toRadians(lat1);
    lon1 = this.toRadians(lon1);

    lat2 = this.toRadians(lat2);
    lon2 = this.toRadians(lon2);

    const d =
      R *
      Math.acos(
        Math.sin(lat1) * Math.sin(lat2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1),
      );

    return d;
  }

  rlDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 3440.065; // Nautical Miles

    lat1 = this.toRadians(lat1);
    lon1 = this.toRadians(lon1);

    lat2 = this.toRadians(lat2);
    lon2 = this.toRadians(lon2);

    const dphi = lat2 - lat1;
    const dlambda = lon2 - lon1;

    const dpsi = Math.log(
      Math.tan(Math.PI / 4 + lat2 / 2) / Math.tan(Math.PI / 4 + lat1 / 2),
    );

    const q = dpsi !== 0 ? dphi / dpsi : Math.cos(lat1);

    const d = Math.sqrt(Math.pow(dphi, 2) + Math.pow(q * dlambda, 2)) * R;

    return d;
  }

  recalculateWaypointDistances(routePoints: any[]) {
    if (!routePoints?.length) return;

    let totalDistance = 0;

    routePoints.forEach((point: any, index: number) => {
      // Normalize sail mode to uppercase 'RL' or 'GC'
      if (point['Sail(RL/GC)']) {
        point['Sail(RL/GC)'] = point['Sail(RL/GC)'].toUpperCase();
        if (point['Sail(RL/GC)'] !== 'GC' && point['Sail(RL/GC)'] !== 'RL') {
          point['Sail(RL/GC)'] = 'RL';
        }
      } else {
        point['Sail(RL/GC)'] = 'RL';
      }

      if (index === 0) {
        point.GC_Distance_NM = 0;
        point.RL_Distance_NM = 0;
        point.Total_Distance_NM = 0;

        point.Total_GC_NM = 0;
        point.Total_RL_NM = 0;

        return;
      }

      const prev = routePoints[index - 1];

      const lat1 = Number(prev.LAT);
      const lon1 = Number(prev.LONG);

      const lat2 = Number(point.LAT);
      const lon2 = Number(point.LONG);

      const gc = this.gcDistance(lat1, lon1, lat2, lon2);
      const rl = this.rlDistance(lat1, lon1, lat2, lon2);

      point.GC_Distance_NM = Number(gc.toFixed(3));
      point.RL_Distance_NM = Number(rl.toFixed(3));

      const selectedDist = point['Sail(RL/GC)'] === 'GC' ? gc : rl;
      totalDistance += selectedDist;

      point.Total_Distance_NM = Number(totalDistance.toFixed(3));

      // Keep legacy fields populated just in case form submit expects them
      point.Total_GC_NM = point.Total_Distance_NM;
      point.Total_RL_NM = point.Total_Distance_NM;
    });
  }
  isRouteComp = false;

  routeCompClick(): void {
    // Block activation if "Multiple route - Multiple speed" is already on
    if (!this.isRouteComp && this.isMultiRouteComp) {
      this.toastr.warning('Turn off "Multiple route - Multiple speed" first.');
      return;
    }

    if (!this.isRouteComp) {
      // Activate Route Comparison
      const currentSpeed = this.requestForm.get('speed')?.value || '';
      const currentConsumption = this.requestForm.get('consumption')?.value || '';
      const currentFuelCost = this.requestForm.get('fuel_cost_per_mt')?.value || '';
      const currentVesselCost = this.requestForm.get('vessel_cost_per_day')?.value || '';

      this.requestForm.removeControl('speed');
      this.requestForm.removeControl('consumption');
      this.requestForm.removeControl('fuel_cost_per_mt');
      this.requestForm.removeControl('vessel_cost_per_day');

      this.requestForm.addControl(
        'routeComparisons',
        this.fb.array([
          this.fb.group({
            speed: [currentSpeed],
            consumption: [currentConsumption],
            fuel_cost_per_mt: [currentFuelCost],
            vessel_cost_per_day: [currentVesselCost],
          }),
        ])
      );

      this.isRouteComp = true;
    } else {
      // Deactivate Route Comparison
      const routeComparison = this.requestForm.get('routeComparisons')?.value?.[0];

      this.requestForm.removeControl('routeComparisons');

      this.requestForm.addControl(
        'speed',
        this.fb.control(routeComparison?.speed || '')
      );

      this.requestForm.addControl(
        'consumption',
        this.fb.control(routeComparison?.consumption || '')
      );

      this.requestForm.addControl(
        'fuel_cost_per_mt',
        this.fb.control(routeComparison?.fuel_cost_per_mt || '')
      );

      this.requestForm.addControl(
        'vessel_cost_per_day',
        this.fb.control(routeComparison?.vessel_cost_per_day || '')
      );

      this.isRouteComp = false;
    }
  }
  isMultiRouteComp = false;

  secondRouteLayer: any;
  secondRouteMarkersLayer: any;

  uploadedRoute1: any[] = [];
  uploadedRoute2: any[] = [];
  multipleRouteAndSpeedCompClick(): void {
    this.isMultiRouteComp = !this.isMultiRouteComp;

    if (this.isMultiRouteComp) {
      // Deactivate "Same route - Multiple speed" if it was on (mutually exclusive)
      if (this.isRouteComp) {
        this.routeCompClick();
      }

      // Activate routeComparisons array for multi-route mode
      if (!this.requestForm.contains('routeComparisons')) {
        const currentSpeed = this.requestForm.get('speed')?.value || '';
        const currentConsumption = this.requestForm.get('consumption')?.value || '';
        const currentFuelCost = this.requestForm.get('fuel_cost_per_mt')?.value || '';
        const currentVesselCost = this.requestForm.get('vessel_cost_per_day')?.value || '';

        this.requestForm.removeControl('speed');
        this.requestForm.removeControl('consumption');
        this.requestForm.removeControl('fuel_cost_per_mt');
        this.requestForm.removeControl('vessel_cost_per_day');

        this.requestForm.addControl(
          'routeComparisons',
          this.fb.array([
            this.fb.group({
              speed: [currentSpeed],
              consumption: [currentConsumption],
              fuel_cost_per_mt: [currentFuelCost],
              vessel_cost_per_day: [currentVesselCost]
            }),
          ])
        );
      }

      this.uploadedRouteMarkers = [];

      // Polish: Copy single route to Route 1 if Route 1 is empty
      if (this.uploadedRoutePoints1.length === 0 && this.uploadedRoutePoints.length > 0) {
        this.uploadedRoutePoints1 = JSON.parse(JSON.stringify(this.uploadedRoutePoints));
        this.uploadedRoute1 = JSON.parse(JSON.stringify(this.uploadedRoutePoints));
        this.uploadedFiles[0] = this.uploadedFile;
      }

      // Redraw multi routes if they exist
      if (this.uploadedRoutePoints1.length > 0) {
        this.drawUploadedRoute(this.uploadedRoutePoints1, true);
      }
      if (this.uploadedRoutePoints2.length > 0) {
        this.drawSecondUploadedRoute(this.uploadedRoutePoints2, true);
      }
    } else {
      // Deactivate multi-route: restore single speed/consumption controls
      if (this.requestForm.contains('routeComparisons')) {
        const routeComparison = this.requestForm.get('routeComparisons')?.value?.[0];
        this.requestForm.removeControl('routeComparisons');
        this.requestForm.addControl('speed', this.fb.control(routeComparison?.speed || ''));
        this.requestForm.addControl('consumption', this.fb.control(routeComparison?.consumption || ''));
        this.requestForm.addControl('fuel_cost_per_mt', this.fb.control(routeComparison?.fuel_cost_per_mt || ''));
        this.requestForm.addControl('vessel_cost_per_day', this.fb.control(routeComparison?.vessel_cost_per_day || ''));
      }

      if (this.secondRouteLayer) {
        this.map.removeLayer(this.secondRouteLayer);
        this.secondRouteLayer = null;
      }

      if (this.secondRouteMarkersLayer) {
        this.map.removeLayer(this.secondRouteMarkersLayer);
        this.secondRouteMarkersLayer = null;
      }

      this.uploadedRouteMarkers2 = [];

      // Polish: Copy Route 1 to single route if single route is empty
      if (this.uploadedRoutePoints.length === 0 && this.uploadedRoutePoints1.length > 0) {
        this.uploadedRoutePoints = JSON.parse(JSON.stringify(this.uploadedRoutePoints1));
        this.uploadedFile = this.uploadedFiles[0];
      }

      // Redraw single route
      if (this.uploadedRoutePoints.length > 0) {
        this.drawUploadedRoute(this.uploadedRoutePoints, true);
      }
    }
  }

  highlightedCardId: string | null = null;

  useSameRouteForRoute2() {
    if (this.uploadedRoutePoints1.length === 0) {
      this.toastr.warning('Please upload Route 1 CSV first');
      return;
    }

    // Deep copy points from Route 1 to Route 2 and set flag to manual so they are marked as draggable/curated
    this.uploadedRoute2 = this.uploadedRoutePoints1.map(p => ({
      ...p,
      flag: 'manual'
    }));

    this.uploadedRoutePoints2 = this.uploadedRoutePoints1.map(p => ({
      ...p,
      flag: 'manual'
    }));

    // Replicate file reference
    if (this.uploadedFiles[0]) {
      this.uploadedFiles[1] = this.uploadedFiles[0];
    } else if (this.uploadedFile) {
      this.uploadedFiles[0] = this.uploadedFile;
      this.uploadedFiles[1] = this.uploadedFile;
    }

    this.recalculateWaypointDistances(this.uploadedRoutePoints2);
    this.drawSecondUploadedRoute(this.uploadedRoutePoints2, true);

    this.toastr.success('Route 1 coordinates copied to Route 2. You can drag Route 2 waypoints on the map.');
  }

  scrollToCard(routeIndex: number, waypointIndex: number) {
    let cardId = '';
    if (routeIndex === 1) {
      cardId = `route1-card-${waypointIndex}`;
    } else if (routeIndex === 2) {
      cardId = `route2-card-${waypointIndex}`;
    } else {
      cardId = `route-card-${waypointIndex}`;
    }

    const el = document.getElementById(cardId);
    if (el) {
      const scrollContainer = el.closest('.fieldsContent') as HTMLElement | null;
      if (scrollContainer) {
        const containerTop = scrollContainer.getBoundingClientRect().top;
        const elTop = el.getBoundingClientRect().top;
        const offset = elTop - containerTop - (scrollContainer.clientHeight / 2) + (el.offsetHeight / 2);
        scrollContainer.scrollBy({ top: offset, behavior: 'smooth' });
      } else {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      this.highlightedCardId = cardId;
      setTimeout(() => {
        if (this.highlightedCardId === cardId) {
          this.highlightedCardId = null;
        }
      }, 3000);
    }
  }

  panToWaypointCard(point: any) {
    const lat = Number(point.LAT);
    const lon = Number(point.LONG);
    if (!isNaN(lat) && !isNaN(lon)) {
      this.map.panTo([lat, lon]);
      this.toastr.info(`Centered map on Waypoint ${point.WPT_No}`);
    }
  }

  hoveredCardId: string | null = null;

  onCardMouseEnter(routeIndex: number, idx: number) {
    let marker: any;
    if (routeIndex === 1) {
      marker = this.uploadedRouteMarkers1[idx];
    } else if (routeIndex === 2) {
      marker = this.uploadedRouteMarkers2[idx];
    } else {
      marker = this.uploadedRouteMarkers[idx];
    }
    if (marker) {
      const iconElement = marker.getElement();
      if (iconElement) {
        const innerDot = iconElement.querySelector('.marker-dot-label');
        if (innerDot) {
          innerDot.classList.add('highlighted-marker');
        }
      }
    }
  }

  onCardMouseLeave(routeIndex: number, idx: number) {
    let marker: any;
    if (routeIndex === 1) {
      marker = this.uploadedRouteMarkers1[idx];
    } else if (routeIndex === 2) {
      marker = this.uploadedRouteMarkers2[idx];
    } else {
      marker = this.uploadedRouteMarkers[idx];
    }
    if (marker) {
      const iconElement = marker.getElement();
      if (iconElement) {
        const innerDot = iconElement.querySelector('.marker-dot-label');
        if (innerDot) {
          innerDot.classList.remove('highlighted-marker');
        }
      }
    }
  }

  clearRoute(routeIndex: number) {
    if (routeIndex === 0) {
      this.uploadedRoutePoints = [];
      this.uploadedRouteMarkers = [];
      this.uploadedFile = null;
      if (this.fileInput?.nativeElement) {
        this.fileInput.nativeElement.value = '';
      }
      if (this.routeLayer) {
        this.map.removeLayer(this.routeLayer);
        this.routeLayer = null;
      }
      if (this.routeMarkersLayer) {
        this.map.removeLayer(this.routeMarkersLayer);
        this.routeMarkersLayer = null;
      }
      this.toastr.info('Route cleared');
    } else if (routeIndex === 1) {
      this.uploadedRoutePoints1 = [];
      this.uploadedRouteMarkers1 = [];
      this.uploadedRoute1 = [];
      if (this.uploadedFiles && this.uploadedFiles.length > 0) {
        this.uploadedFiles[0] = null as any;
      }
      if (this.route1Input?.nativeElement) {
        this.route1Input.nativeElement.value = '';
      }
      if (this.routeLayer) {
        this.map.removeLayer(this.routeLayer);
        this.routeLayer = null;
      }
      if (this.routeMarkersLayer) {
        this.map.removeLayer(this.routeMarkersLayer);
        this.routeMarkersLayer = null;
      }
      this.toastr.info('Route 1 cleared');
    } else if (routeIndex === 2) {
      this.uploadedRoutePoints2 = [];
      this.uploadedRouteMarkers2 = [];
      this.uploadedRoute2 = [];
      if (this.uploadedFiles && this.uploadedFiles.length > 1) {
        this.uploadedFiles[1] = null as any;
      }
      if (this.route2Input?.nativeElement) {
        this.route2Input.nativeElement.value = '';
      }
      if (this.secondRouteLayer) {
        this.map.removeLayer(this.secondRouteLayer);
        this.secondRouteLayer = null;
      }
      if (this.secondRouteMarkersLayer) {
        this.map.removeLayer(this.secondRouteMarkersLayer);
        this.secondRouteMarkersLayer = null;
      }
      this.toastr.info('Route 2 cleared');
    }
  }

  getRouteDistance(points: any[], type?: 'GC' | 'RL'): number {
    if (!points || points.length === 0) return 0;
    const lastPoint = points[points.length - 1];
    return lastPoint.Total_Distance_NM || 0;
  }

  get routeComparisons(): FormArray {
    return this.requestForm.get('routeComparisons') as FormArray;
  }

  addRouteComparison(): void {
    const group = this.fb.group({
      speed: [''],
      consumption: [''],
      fuel_cost_per_mt: [''],
      vessel_cost_per_day: [''],
    });
    this.routeComparisons.push(group);
    
    this.autoFillOptionConsumption(group);

    group.get('speed')?.valueChanges.subscribe(() => {
      this.autoFillOptionConsumption(group);
    });
  }

  removeRouteComparison(index: number): void {
    if (this.routeComparisons.length > 1) {
      this.routeComparisons.removeAt(index);
    }
  }



  // ===========================================================================
  // MARITIME ROUTING & OVERLAYS
  // ===========================================================================

  async toggleMapMode() {
    this.isGlobeMode = !this.isGlobeMode;

    if (this.isGlobeMode) {
      if (!this.cesiumLoaded) {
        await this.loadCesiumLibrary();
      }
      // Small delay to let the globe div become visible before init
      setTimeout(() => {
        this.initializeGlobe();
        if (this.currentRouteCoords.length > 0) {
          this.drawRouteOnGlobe(this.currentRouteCoords);
          // Ensure it's centered
          if (this.globeViewer) {
            this.globeViewer.resize();
            setTimeout(() => {
              this.globeViewer.zoomTo(this.globeViewer.entities);
            }, 300);
          }
        }
      }, 200);
    } else {
      // Invalidate Leaflet map size when switching back to 2D
      setTimeout(() => this.map.invalidateSize(), 100);
    }
  }

  private loadCesiumLibrary(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).Cesium) {
        this.cesiumLoaded = true;
        resolve();
        return;
      }

      // Set base URL before loading
      (window as any).CESIUM_BASE_URL = 'assets/cesium/';

      // Load Cesium CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'assets/cesium/Widgets/widgets.css';
      document.head.appendChild(link);

      // Load Cesium JS
      const script = document.createElement('script');
      script.src = 'assets/cesium/Cesium.js';
      script.onload = () => {
        this.cesiumLoaded = true;
        resolve();
      };
      script.onerror = (e) => {
        console.error('Failed to load CesiumJS', e);
        this.toastr.error('Failed to load 3D Globe library');
        this.isGlobeMode = false;
        reject(e);
      };
      document.head.appendChild(script);
    });
  }

  private initializeGlobe() {
    if (this.globeViewer) return;

    // Create viewer with minimal UI
    this.globeViewer = new Cesium.Viewer('globe', {
      baseLayerPicker: false,
      geocoder: false,
      timeline: false,
      animation: false,
      homeButton: false,
      sceneModePicker: false,
      navigationHelpButton: false,
      fullscreenButton: false,
      selectionIndicator: false,
      infoBox: false,
      creditContainer: document.createElement('div'),
      imageryProvider: false as any,
    });

    // Add ArcGIS Light Gray Canvas tiles (free, no token needed)
    this.globeViewer.imageryLayers.addImageryProvider(
      new Cesium.UrlTemplateImageryProvider({
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
        maximumLevel: 16,
      }),
    );
    this.globeViewer.imageryLayers.addImageryProvider(
      new Cesium.UrlTemplateImageryProvider({
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        maximumLevel: 16,
      }),
    );

    // Globe visual settings
    this.globeViewer.scene.globe.enableLighting = false;
    this.globeViewer.scene.skyAtmosphere.show = true;

    // Force a resize calculation
    setTimeout(() => {
      if (this.globeViewer) {
        this.globeViewer.resize();
      }
    }, 200);

    // Set initial camera to a nice overview ONLY if no route is loaded yet
    if (this.currentRouteCoords.length === 0) {
      this.globeViewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(80, 20, 15000000),
        duration: 0,
      });
    }

    // Sync any active overlays
    this.syncRoutingOverlaysToGlobe();
  }

  private addDtnLayerToGlobe(tileSetId: string) {
    if (!this.globeViewer || !this.token) return;

    const dtnUrl = `https://map.api.dtn.com/v2/tiles/fcst-onefx-wind-speed-contours/${tileSetId}/{z}/{x}/{y}?unit=metric&token=${this.token}`;

    this.globeDtnImageryLayer =
      this.globeViewer.imageryLayers.addImageryProvider(
        new Cesium.UrlTemplateImageryProvider({
          url: dtnUrl,
          minimumLevel: 2,
          maximumLevel: 10,
          credit: new Cesium.Credit('DTN Weather'),
        }),
      );
    // Start hidden — user toggles it on
    this.globeDtnImageryLayer.show = this.globeWeatherVisible;
  }

  toggleGlobeWeather(): void {
    this.globeWeatherVisible = !this.globeWeatherVisible;

    if (this.globeDtnImageryLayer) {
      this.globeDtnImageryLayer.show = this.globeWeatherVisible;
    } else if (this.globeWeatherVisible) {
      // First time toggling on — check if we need to fetch token/tileset
      if (!this.token || !this.currentTileSetId) {
        this.dtnService.getToken().subscribe({
          next: (res: any) => {
            this.token = res.data.access_token;
            const layerId = 'fcst-onefx-wind-speed-contours';
            this.dtnService.getLatestTileSetId(layerId, this.token!).subscribe({
              next: (tileSetId: string) => {
                this.currentTileSetId = tileSetId;
                this.addDtnLayerToGlobe(tileSetId);
                if (this.globeDtnImageryLayer) {
                  this.globeDtnImageryLayer.show = true;
                }
              },
            });
          },
        });
      } else {
        this.addDtnLayerToGlobe(this.currentTileSetId);
        if (this.globeDtnImageryLayer) {
          this.globeDtnImageryLayer.show = true;
        }
      }
    }
  }

  globeZoomIn(): void {
    if (!this.globeViewer) return;
    this.globeViewer.camera.zoomIn(
      this.globeViewer.camera.positionCartographic.height * 0.4,
    );
  }

  globeZoomOut(): void {
    if (!this.globeViewer) return;
    this.globeViewer.camera.zoomOut(
      this.globeViewer.camera.positionCartographic.height * 0.6,
    );
  }

  private drawRouteOnGlobe(coordsOrGeojson: any) {
    if (!this.globeViewer) return;

    let coords: [number, number][] = [];
    if (Array.isArray(coordsOrGeojson)) {
      coords = coordsOrGeojson;
    } else if (coordsOrGeojson?.geometry?.coordinates) {
      coords = coordsOrGeojson.geometry.coordinates.map((c: any) => [c[1], c[0]]);
    }

    if (coords.length < 2) return;

    if (this.globeRouteDataSource) {
      this.globeViewer.dataSources.remove(this.globeRouteDataSource);
    }

    const degreesArray: number[] = [];
    coords.forEach(([lat, lon]) => degreesArray.push(lon, lat));

    const entity = this.globeViewer.entities.add({
      polyline: {
        positions: Cesium.Cartesian3.fromDegreesArray(degreesArray),
        width: 4,
        material: Cesium.Color.fromCssColorString('#3b82f6'),
        clampToGround: true,
      },
    });

    const startPort = this.requestForm.get('startPortName')?.value || 'Start';
    const endPort = this.requestForm.get('endPortName')?.value || 'End';

    // Add markers at start and end
    this.globeViewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(coords[0][1], coords[0][1]),
      point: { pixelSize: 10, color: Cesium.Color.fromCssColorString('#10b981'), outlineColor: Cesium.Color.WHITE, outlineWidth: 2 },
      label: { text: startPort, font: '14px sans-serif', verticalOrigin: Cesium.VerticalOrigin.BOTTOM, pixelOffset: new Cesium.Cartesian2(0, -15) }
    });
    this.globeViewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(coords[coords.length - 1][1], coords[coords.length - 1][0]),
      point: { pixelSize: 10, color: Cesium.Color.fromCssColorString('#ef4444'), outlineColor: Cesium.Color.WHITE, outlineWidth: 2 },
      label: { text: endPort, font: '14px sans-serif', verticalOrigin: Cesium.VerticalOrigin.BOTTOM, pixelOffset: new Cesium.Cartesian2(0, -15) }
    });

    // Zoom to route
    this.globeViewer.zoomTo(entity);
  }

  private addZoneToGlobe(type: string, data?: any) {
    if (!this.globeViewer) return;
    const geojsonData = data || this.zoneDataCache[type];
    if (!geojsonData) return;

    if (this.globeDataSources[type]) {
      this.globeViewer.dataSources.remove(this.globeDataSources[type]);
    }

    const styles: any = {
      'eca': { color: '#10b981', opacity: 0.2 },
      'marpol': { color: '#0d9488', opacity: 0.25 },
      'hra': { color: '#ef4444', opacity: 0.25 },
      'piracy': { color: '#f97316', opacity: 0.25 },
      'tss': { color: '#8b5cf6', opacity: 0.3 },
      'inl': { color: '#22d3ee', opacity: 0.15 },
    };
    const style = styles[type] || { color: '#ffffff', opacity: 0.5 };

    Cesium.GeoJsonDataSource.load(geojsonData, {
      stroke: Cesium.Color.fromCssColorString(style.color),
      fill: Cesium.Color.fromCssColorString(style.color).withAlpha(style.opacity),
      strokeWidth: 2
    }).then((ds: any) => {
      this.globeDataSources[type] = ds;
      this.globeViewer.dataSources.add(ds);
      ds.entities.values.forEach((e: any) => {
        if (e.billboard) e.show = false;
        if (e.polygon) e.polygon.classificationType = Cesium.ClassificationType.BOTH;
      });
    });
  }

  private syncRoutingOverlaysToGlobe() {
    if (!this.globeViewer) return;
    ['eca', 'marpol', 'hra', 'piracy', 'tss', 'inl'].forEach(type => {
      if (this.layerState[type]) this.addZoneToGlobe(type);
    });
    if (this.layerState.ports) this.renderPortsOnGlobe();
    if (this.layerState.gates) this.renderGatesOnGlobe();
  }

  private renderPortsOnGlobe() {
    if (!this.globeViewer || !this.zoneDataCache['ports-major']) return;
    const type = 'ports-major';
    if (this.globeDataSources[type]) this.globeViewer.dataSources.remove(this.globeDataSources[type]);

    Cesium.GeoJsonDataSource.load(this.zoneDataCache[type], {
      markerSize: 12,
      markerColor: Cesium.Color.fromCssColorString('#3b82f6')
    }).then((ds: any) => {
      this.globeDataSources[type] = ds;
      this.globeViewer.dataSources.add(ds);
    });
  }

  private renderGatesOnGlobe() {
    if (!this.globeViewer || this.gatesData.length === 0) return;
    const type = 'gates';
    if (this.globeDataSources[type]) this.globeViewer.dataSources.remove(this.globeDataSources[type]);

    const ds = new Cesium.CustomDataSource(type);
    this.gatesData.forEach(gate => {
      const isLocked = this.activeGates.has(gate.ShortCode);
      ds.entities.add({
        id: `gate-${gate.ShortCode}`,
        position: Cesium.Cartesian3.fromDegrees(gate.Lon, gate.LatGeodetic),
        point: {
          pixelSize: isLocked ? 14 : 10,
          color: isLocked ? Cesium.Color.fromCssColorString('#ef4444') : Cesium.Color.fromCssColorString('#3b82f6'),
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 3,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        },
        label: {
          text: gate.Name + (isLocked ? ' (MANDATORY)' : ' (OPTIONAL)'),
          font: 'bold 11px sans-serif',
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          pixelOffset: new Cesium.Cartesian2(0, -18),
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        }
      });
    });
    this.globeDataSources[type] = ds;
    this.globeViewer.dataSources.add(ds);
  }

  toggleRoutingLayer(type: string) {
    const group = this.routingOverlayGroups[type];
    if (!group) {
      this.routingOverlayGroups[type] = L.layerGroup();
    }
    const targetGroup = this.routingOverlayGroups[type];

    if (this.layerState[type]) {
      if (!this.map.hasLayer(targetGroup)) this.map.addLayer(targetGroup);

      // If we already have the data in cache, just add it to globe if in 3D mode
      if (this.isGlobeMode && this.zoneDataCache[type]) {
        this.addZoneToGlobe(type);
      }

      if (!this.loadedRoutingLayers.has(type)) {
        this.routingService.getClippedZone(type).subscribe({
          next: (data: any) => {
            this.zoneDataCache[type] = data; // Cache the data
            L.geoJSON(data, {
              style: (feature) => {
                const styles: any = {
                  'eca': { color: '#10b981', weight: 1, fillColor: '#10b981', fillOpacity: 0.15 },
                  'marpol': { color: '#0d9488', weight: 1, fillColor: '#0d9488', fillOpacity: 0.2 },
                  'hra': { color: '#ef4444', weight: 1, fillColor: '#ef4444', fillOpacity: 0.2 },
                  'piracy': { color: '#f97316', weight: 1, fillColor: '#f97316', fillOpacity: 0.2 },
                  'tss': { color: '#8b5cf6', weight: 1.5, fillColor: '#8b5cf6', fillOpacity: 0.25 },
                  'inl': { color: '#22d3ee', weight: 1.5, dashArray: '5, 5', fillColor: '#22d3ee', fillOpacity: 0.1 },
                };
                const baseStyle = styles[type] || { color: '#333' };
                if (feature?.geometry?.type?.includes('LineString')) {
                  return { ...baseStyle, fillOpacity: 0 };
                }
                return baseStyle;
              },
              onEachFeature: (feature, layer) => {
                if (feature?.properties?.name) layer.bindTooltip(feature.properties.name);
              }
            }).addTo(targetGroup);
            this.loadedRoutingLayers.add(type);

            // Sync to globe if in 3D mode
            if (this.isGlobeMode) this.addZoneToGlobe(type, data);
          }
        });
      }
    } else {
      if (this.map.hasLayer(targetGroup)) this.map.removeLayer(targetGroup);
      if (this.globeViewer && this.globeDataSources[type]) {
        this.globeViewer.dataSources.remove(this.globeDataSources[type]);
        delete this.globeDataSources[type];
      }
    }
  }

  toggleRoutingPorts(type: string) {
    const groupName = 'ports-' + type;
    if (!this.routingOverlayGroups[groupName]) {
      this.routingOverlayGroups[groupName] = L.layerGroup();
    }
    const targetGroup = this.routingOverlayGroups[groupName];

    if (this.layerState.ports) {
      if (!this.map.hasLayer(targetGroup)) targetGroup.addTo(this.map);
      if (this.isGlobeMode) this.renderPortsOnGlobe();

      if (!this.loadedRoutingLayers.has(groupName)) {
        this.routingService.getAllPorts(type).subscribe((data: any) => {
          this.zoneDataCache[groupName] = data;
          L.geoJSON(data, {
            pointToLayer: (feat, latlng) => L.circleMarker(latlng, {
              radius: 3, fillColor: "#3b82f6", color: "#fff", weight: 1, fillOpacity: 1
            }).bindTooltip(feat?.properties?.name)
          }).addTo(targetGroup);
          this.loadedRoutingLayers.add(groupName);
          if (this.isGlobeMode) this.renderPortsOnGlobe();
        });
      }
    } else {
      if (this.map.hasLayer(targetGroup)) this.map.removeLayer(targetGroup);
      if (this.globeViewer && this.globeDataSources[groupName]) {
        this.globeViewer.dataSources.remove(this.globeDataSources[groupName]);
        delete this.globeDataSources[groupName];
      }
    }
  }

  toggleRoutingGates() {
    if (!this.routingOverlayGroups['gates']) {
      this.routingOverlayGroups['gates'] = L.layerGroup();
    }
    const group = this.routingOverlayGroups['gates'];

    if (this.layerState.gates) {
      if (!this.map.hasLayer(group)) group.addTo(this.map);
      if (this.isGlobeMode) this.renderGatesOnGlobe();

      if (this.gatesData.length === 0) {
        this.routingService.getAdvancedRouting().subscribe((data: any) => {
          this.gatesData = data;
          this.renderGates();
          if (this.isGlobeMode) this.renderGatesOnGlobe();
        });
      } else {
        this.renderGates();
      }
    } else {
      group.clearLayers();
      if (this.map.hasLayer(group)) this.map.removeLayer(group);
      if (this.globeViewer && this.globeDataSources['gates']) {
        this.globeViewer.dataSources.remove(this.globeDataSources['gates']);
        delete this.globeDataSources['gates'];
      }
    }
  }

  toggleSingleGate(gate: AdvancedRouteGate) {
    if (this.activeGates.has(gate.ShortCode)) {
      this.activeGates.delete(gate.ShortCode);
    } else {
      this.activeGates.add(gate.ShortCode);
    }
    this.renderGates();
    if (this.isGlobeMode) this.renderGatesOnGlobe();
  }

  private renderGates() {
    const group = this.routingOverlayGroups['gates'];
    group.clearLayers();

    // Ensure global toggle function exists for the popup
    if (!(window as any).toggleRoutingGate) {
      (window as any).toggleRoutingGate = (shortCode: string) => {
        const gate = this.gatesData.find(g => g.ShortCode === shortCode);
        if (gate) {
          this.toggleSingleGate(gate);
        }
      };
    }

    this.gatesData.forEach(gate => {
      const isLocked = this.activeGates.has(gate.ShortCode);

      const icon = L.divIcon({
        className: 'custom-gate-icon',
        html: `
          <div class="gate-marker-wrapper ${isLocked ? 'locked' : ''}">
            <div class="gate-marker-circle">
              <span class="material-icons">${isLocked ? 'lock' : 'lock_open'}</span>
            </div>
          </div>
        `,
        iconSize: [28, 28],
        iconAnchor: [14, 14]
      });

      const popupHtml = `
        <div class="gate-premium-popup">
          <div class="popup-header">
            <h4>${gate.Name}</h4>
          </div>
          <p class="popup-coords">${gate.ShortCode} | ${gate.LatGeodetic.toFixed(4)}, ${gate.Lon.toFixed(4)}</p>
          <div class="popup-action">
            <label class="premium-switch">
              <input type="checkbox" ${isLocked ? 'checked' : ''} onchange="window.toggleRoutingGate('${gate.ShortCode}')">
              <span class="slider"></span>
            </label>
            <span class="toggle-label">${isLocked ? 'MANDATORY' : 'OPTIONAL'}</span>
          </div>
        </div>
      `;

      L.marker([gate.LatGeodetic, gate.Lon], { icon })
        .bindPopup(popupHtml, {
          className: 'gate-popup-custom',
          maxWidth: 250,
          minWidth: 180,
          offset: [0, -10]
        })
        .addTo(group);
    });
  }

  calculateMaritimeRoute() {
    const originCoords = [this.requestForm.get('startLat')?.value, this.requestForm.get('startLon')?.value];
    const destCoords = [this.requestForm.get('endLat')?.value, this.requestForm.get('endLon')?.value];

    if (!originCoords[0] || !destCoords[0]) {
      this.toastr.warning('Please select start and end points');
      return;
    }

    const combinedWps = this.viaPoints.map(p => [Number(p.lat), Number(p.lon)]);

    const reqData = {
      origin: originCoords,
      destination: destCoords,
      waypoints: combinedWps,
      speed_knots: this.routingSpeed,
      vessel_type: this.routingVesselType,
      avoid_hra: this.avoidHra,
      avoid_suez: this.avoidSuez,
      avoid_panama: this.avoidPanama,
    };

    this.isRoutingLoading = true;
    this.routingService.calculateRoute(reqData).subscribe({
      next: (result: any) => {
        if (result.status === 'success') {
          this.routingResults = result;
          this.drawMaritimeRoute(result.route_geojson || result.route);
        } else {
          this.toastr.error('Error: ' + (result.detail || 'Route calculation failed'));
        }
        this.isRoutingLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Request failed. See console.');
        this.isRoutingLoading = false;
      }
    });
  }

  private drawMaritimeRoute(routeData: any) {
    if (this.routingRouteLayer) this.map.removeLayer(this.routingRouteLayer);
    this.routingRouteMarkers.forEach(m => this.map.removeLayer(m));
    this.routingRouteMarkers = [];

    this.routingRouteLayer = L.geoJSON(routeData, {
      style: { color: '#2563eb', weight: 4, opacity: 0.9 }
    }).addTo(this.map);

    const coords = routeData.geometry.coordinates;
    coords.forEach((coord: any, idx: number) => {
      if (idx !== 0 && idx !== coords.length - 1 && idx % 10 === 0) {
        const m = L.circleMarker([coord[1], coord[0]], {
          radius: 2,
          color: '#3b82f6',
          fillOpacity: 1,
          stroke: false
        }).addTo(this.map);
        this.routingRouteMarkers.push(m);
      }
    });

    // Start/End markers
    const startM = L.circleMarker([coords[0][1], coords[0][0]], { radius: 6, color: '#10b981', fillOpacity: 1, weight: 2, stroke: true })
      .bindPopup("Origin").addTo(this.map);
    const endM = L.circleMarker([coords[coords.length - 1][1], coords[coords.length - 1][0]], { radius: 6, color: '#ef4444', fillOpacity: 1, weight: 2, stroke: true })
      .bindPopup("Destination").addTo(this.map);

    this.routingRouteMarkers.push(startM, endM);

    this.currentRouteCoords = coords.map((c: any) => [c[1], c[0]]);

    if (this.isGlobeMode) {
      this.drawRouteOnGlobe(routeData);
    }
  }

  vesselTcpSpeedConsumption: any[] = [];
  isTcpMenuOpen = false;

  getObjectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  private lastFetchedTcpImo?: string;
  private isFetchingTcp = false;

  fetchTcpSpeedConsumption(imo: any) {
    const strImo = String(imo || '').trim();
    if (!strImo) {
      this.vesselTcpSpeedConsumption = [];
      this.isTcpMenuOpen = false;
      this.lastFetchedTcpImo = undefined;
      return;
    }
    if (this.lastFetchedTcpImo === strImo && (this.vesselTcpSpeedConsumption?.length > 0 || this.isFetchingTcp)) {
      return;
    }
    this.lastFetchedTcpImo = strImo;
    this.isFetchingTcp = true;

    this.requestFormService.getVesselTcpSpeedConsumption(strImo).subscribe({
      next: (data) => {
        this.isFetchingTcp = false;
        this.vesselTcpSpeedConsumption = data || [];
        if (this.vesselTcpSpeedConsumption.length > 0) {
          this.isTcpMenuOpen = true;
        }
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      },
      error: () => {
        this.isFetchingTcp = false;
        this.vesselTcpSpeedConsumption = [];
        this.isTcpMenuOpen = false;
      }
    });
  }

  getFilteredTcpSpeedConsumption(): any[] {
    const selectedCond = this.requestForm.get('condition')?.value;
    if (!selectedCond || selectedCond.trim() === '') {
      return this.vesselTcpSpeedConsumption;
    }
    return this.vesselTcpSpeedConsumption.filter(item =>
      item.condition.toLowerCase() === selectedCond.toLowerCase()
    );
  }

  autoFillConsumption(): void {
    const speed = this.requestForm.get('speed')?.value;
    const condition = this.requestForm.get('condition')?.value;
    if (!speed || !condition) {
      this.requestForm.get('consumption')?.setValue('', { emitEvent: false });
      return;
    }
    const matchedVal = this.lookupConsumption(condition, speed);
    this.requestForm.get('consumption')?.setValue(matchedVal || '', { emitEvent: false });
  }

  autoFillOptionConsumption(group: FormGroup): void {
    const speed = group.get('speed')?.value;
    const condition = this.requestForm.get('condition')?.value;
    if (!speed || !condition) {
      group.get('consumption')?.setValue('', { emitEvent: false });
      return;
    }
    const matchedVal = this.lookupConsumption(condition, speed);
    group.get('consumption')?.setValue(matchedVal || '', { emitEvent: false });
  }

  lookupConsumption(condition: string, speed: any): string {
    if (!this.vesselTcpSpeedConsumption || this.vesselTcpSpeedConsumption.length === 0) {
      return '';
    }
    const speedStr = parseFloat(speed).toString();
    const curve = this.vesselTcpSpeedConsumption.find(
      (item: any) => item.condition.toLowerCase() === condition.toLowerCase()
    );
    if (curve && curve.speed_consumption) {
      if (curve.speed_consumption[speedStr] !== undefined) {
        return curve.speed_consumption[speedStr];
      }
      const parsedSpeed = parseFloat(speed);
      for (const key of Object.keys(curve.speed_consumption)) {
        if (Math.abs(parseFloat(key) - parsedSpeed) < 0.01) {
          return curve.speed_consumption[key];
        }
      }
    }
    return '';
  }

   tabChanged(event: MatTabChangeEvent) {
    this.selectedTab = event.index === 0; // Meraki = true, ABB = false

  // Optional: reset selected type if not available in new tab
  if (!this.reportTypes.includes(this.selectedType)) {
    this.selectedType = this.reportTypes[0];
  }
    }
    get reportTypes(): string[] {
  return this.selectedTab
    ? this.allReportTypes.meraki
    : this.allReportTypes.abb;
}

routePointsExpanded = true;
route1PointsExpanded = true;
route2PointsExpanded = true;

toggleRoutePoints(): void {
  this.routePointsExpanded = !this.routePointsExpanded;
}

toggleRoute1Points(): void {
  this.route1PointsExpanded = !this.route1PointsExpanded;
}

toggleRoute2Points(): void {
  this.route2PointsExpanded = !this.route2PointsExpanded;
}

}
